/* ═══════════════════════════════════════════════════════════════════════
   ISOFIN — Ergebnis speichern & wiederherstellen (v530, 2026-09-15)
   ───────────────────────────────────────────────────────────────────────
   Port der Dashboard-Speicherfunktion (isodash-share/-contact) auf die
   isowiz-Ergebnisseite (/pages/kalkulator step-4). KEIN 26-isowiz-Code
   wird verändert (ADR-019) — dieses Script:

   TEIL A — Loader-Gate + Restore:
     page.kalkulator.liquid startet den isowiz-Loader nicht mehr direkt,
     sondern über dieses Script (window.__ISO_SHARE_CFG__.loader).
     • Ohne ?p=  → Loader wird sofort injiziert (Verhalten wie bisher).
     • Mit  ?p=  → gespeicherte Eingaben decodieren, isowiz-Library laden
       (storage→config→calculations, wie iso-loesung-flow v337),
       calculateFinalAnalysis(state) rechnet + persistiert selbst,
       Cart-Menge absolut setzen (Loader-Resume-Bedingung),
       __ISOWIZ_START_INTENT__ = step-4 → Loader injizieren → Ergebnisseite.
       Fehler → sauber in den normalen Wizard-Start fallen.

   TEIL B — Speicher-UI auf step-4:
     „💾 Berechnung speichern"-Button (oben + unten) → Schublade mit
     • Per WhatsApp an mich senden (eigene Nummer, Self-Send)
     • Per E-Mail an mich senden (mailto, vorbefüllt)
     • Link kopieren
     Jede Variante enthält: Wanddaten, Ergebnis, 🔗 Wiederherstell-Link
     (?p=…) und 🛒 Bestell-Link (Cart-Permalink /cart/VARIANT:Flaschen).

   Link-Format ?p= ist identisch zum Dashboard (isodash-share.js) —
   alte Dashboard-Links bleiben damit prinzipiell decodierbar.
   Kontakt-Kanon (ADR-022): 0170 844 94 72 · 0800 22 66 245.
   ═══════════════════════════════════════════════════════════════════════ */
(function (w, d) {
  "use strict";
  if (w.__ISO_ERGEBNIS_SHARE__) return;
  w.__ISO_ERGEBNIS_SHARE__ = 1;

  var CFG = w.__ISO_SHARE_CFG__ || {};
  var VARIANT_ID = String(CFG.variantId || "55049427616117");
  var KALK_PATH = CFG.kalkUrl || "/pages/kalkulator";

  /* ── GA4-Ausgang (v529, 10.09.2026) ───────────────────────────────────
     Bis v528 ging JEDES Ereignis dieser Datei ausschliesslich an Logr3;
     window.isofinGA (definiert in layout/theme.liquid) wurde nie gerufen.
     Folge: In GA4 stand zum Speichern-Knopf kein einziges Ereignis, obwohl
     Logr3 alles mitschrieb — die Quote liess sich nur ueber Klaviyo schaetzen.

     Bewusst NICHT alle Logr3-Namen weiterreichen. Logr3 liefert die Nutzlast
     nicht aus, deshalb tragen die Namen dort Varianten im Namen (siehe
     groessenklasse, _inline_top, _return_email …). GA4 kann Parameter, also
     gehen hier wenige stabile Namen mit Parametern raus. Das haelt die
     Ereignisliste sauber und macht die Namen in Google Ads importierbar.

     Logr3 bleibt unveraendert — die dortigen Namen sind Bestandsdaten. */
  var GA_MAP = {
    ergebnis_save_open_btn:      ["ergebnis_save_open",     { pos: "button" }],
    ergebnis_save_open_exit:     ["ergebnis_save_open",     { pos: "exit" }],
    ergebnis_save_fold_open:     ["ergebnis_save_open",     { pos: "fold" }],
    ergebnis_save_email:         ["ergebnis_save_submit",   { kanal: "email" }],
    ergebnis_save_whatsapp:      ["ergebnis_save_submit",   { kanal: "whatsapp" }],
    ergebnis_save_copy:          ["ergebnis_save_submit",   { kanal: "link" }],
    ergebnis_save_email_klaviyo: ["ergebnis_save_success",  { kanal: "email" }],
    ergebnis_save_email_mailto:  ["ergebnis_save_fallback", { kanal: "mailto" }],
    ergebnis_guide_optin_ok:     ["ergebnis_guide_optin",   { status: "ok" }],
    ergebnis_guide_optin_fehler: ["ergebnis_guide_optin",   { status: "fehler" }],
    ergebnis_restore:            ["ergebnis_restore",       { typ: "berechnung" }],
    ergebnis_save_return:        ["ergebnis_restore",       { typ: "kasse" }],
    ergebnis_restore_error:      ["ergebnis_restore_error", {}],
    /* v550: Rückruf-Häkchen im Speicherfeld — ein Name, Zustand als Parameter. */
    ergebnis_rueckruf_haekchen:  ["ergebnis_rueckruf",      { status: "haekchen" }],
    ergebnis_rueckruf_ok:        ["ergebnis_rueckruf",      { status: "ok" }],
    ergebnis_rueckruf_fehler:    ["ergebnis_rueckruf",      { status: "fehler" }],
    ergebnis_rueckruf_festnetz:  ["ergebnis_rueckruf",      { status: "festnetz" }],
    /* v572: Rückruf-Kasten im Speicherfeld ist zugeklappt — erstes Aufklappen je Karte. */
    ergebnis_rueckruf_auf:       ["ergebnis_rueckruf",      { status: "aufgeklappt" }],
    ergebnis_speichern_hendrik_tel: ["ergebnis_contact_click", { kanal: "speichern_telefon" }],
    ergebnis_speichern_hendrik_wa:  ["ergebnis_contact_click", { kanal: "speichern_whatsapp" }],
    /* Entwurf 27.09.: Ausstiegsfenster als Frage — ein Name, Antwort als Parameter. */
    ergebnis_exit_frage_shown:     ["ergebnis_exit_frage",  { schritt: "gezeigt" }],
    ergebnis_exit_grund_wand:      ["ergebnis_exit_grund",  { wahl: "wand" }],
    ergebnis_exit_grund_garantie:  ["ergebnis_exit_grund",  { wahl: "garantie" }],
    ergebnis_exit_grund_anwendung: ["ergebnis_exit_grund",  { wahl: "anwendung" }],
    ergebnis_exit_grund_spaeter:   ["ergebnis_exit_grund",  { wahl: "spaeter" }],
    ergebnis_exit_grund_keins:     ["ergebnis_exit_grund",  { wahl: "keins" }]
  };

  function ga4(ev, data) {
    var m = GA_MAP[ev];
    if (!m) return;
    try {
      if (typeof w.isofinGA !== "function") return;
      var p = { page_path: (w.location && w.location.pathname) || "" };
      var fest = m[1], k;
      for (k in fest) { if (Object.prototype.hasOwnProperty.call(fest, k)) p[k] = fest[k]; }
      if (data) {
        if (data.bottles != null) p.flaschen = Number(data.bottles) || 0;
        if (data.src) p.src = String(data.src);
        /* v588: Geraet beim Speichern (das Geraet des Ereignisses kennt GA4 selbst). */
        if (data.geraet_speichern) p.geraet_speichern = String(data.geraet_speichern);
      }
      w.isofinGA(m[0], p);
    } catch (e) {}
  }

  function track(ev, data) {
    /* A6: ohne step landet das Event auf /goal und faelscht den Kauf-Zaehler "converted". */
    try { if (typeof w.logr3Track === "function") w.logr3Track(ev, Object.assign({ step: true }, data || {})); } catch (e) {}
    ga4(ev, data);
  }
  /* B4 (v503, Dev-Auftrag 14.08.): Logr3 liefert Payload nicht aus — die
     Bestellgroesse muss deshalb im Event-NAMEN stehen. Klassengrenzen entlang
     der Preisstaffel: bis 10 klein, bis 49 mittel, bis 249 gross (ab 50 gilt
     18,90 EUR), darueber Grossprojekt (17,90 EUR). */
  function groessenklasse(n) {
    n = Number(n) || 0;
    if (n <= 10) return "s";
    if (n <= 49) return "m";
    if (n <= 249) return "l";
    return "xl";
  }
  /* v588 (04.10.2026): Geraet beim Speichern. Frage: Speichern Handy-Nutzer und
     kaufen spaeter am PC? Bisher nicht belegbar — die Klicks in der Mail kamen je
     zur Haelfte vom PC, aber das Geraet beim Speichern wurde nirgends erfasst.
     Jetzt geht es mit in die Links (Berechnung &dev=, Kasse
     attributes[isofin_save_device]) und ins Klaviyo-Ereignis; beim Oeffnen des
     Berechnungs-Links kommt das Oeffnungsgeraet als isofin_open_device dazu.
     Nur die Klasse (mobil/tablet/desktop), kein Browser, kein Modell.
     Tablet zuerst pruefen: Android-Tablets melden userAgentData.mobile = false,
     iPads mit iPadOS geben sich als „Macintosh“ mit Touch aus. In der
     Desktop-Ansicht melden sich iPhones ebenfalls als „Macintosh“ mit Touch und
     Android-Geraete als „X11; Linux“ mit Touch (ChromeOS: „X11; CrOS“, bleibt
     desktop) — dort entscheidet die kurze Bildschirmseite: unter 600 px = Handy.
     Rueckruf-Links (Kanal rueckruf) bekommen KEIN Geraet: Sie oeffnet Hendrik,
     nicht der Kunde — sonst zaehlte jede Rueckrufbitte als Wechsel zum PC. */
  var GERAETE_RE = /^(mobil|tablet|desktop)$/;
  function geraetKlasse() {
    try {
      var n = w.navigator || {}, ua = String(n.userAgent || ""), tp = n.maxTouchPoints || 0;
      if ((/Macintosh/.test(ua) || /X11; Linux/.test(ua)) && tp > 1) {
        var sc = w.screen || {}, kurz = Math.min(sc.width || 0, sc.height || 0);
        return kurz && kurz < 600 ? "mobil" : "tablet";
      }
      if (/iPad|Tablet|PlayBook|Silk|Kindle/i.test(ua) || (/Android/i.test(ua) && !/Mobile/i.test(ua))) return "tablet";
      if (n.userAgentData && typeof n.userAgentData.mobile === "boolean") return n.userAgentData.mobile ? "mobil" : "desktop";
      if (/Mobi|iPhone|iPod|Android|Windows Phone/i.test(ua)) return "mobil";
      return "desktop";
    } catch (e) { return ""; }
  }
  var GERAET = geraetKlasse();
  function mitGeraet(channel) { return !!(channel && channel !== "rueckruf" && GERAET); }

  /* ══ Encode / Decode — Format identisch zu isodash-share.js ══ */
  function encodeInputs(a) {
    if (!a) return null;
    var c = {};
    if (a.moistureType) c.m = a.moistureType;
    if (a.barrierType) c.b = a.barrierType;
    if (a.masonryType) c.t = a.masonryType;
    if (a.wallThicknessCm != null) c.w = a.wallThicknessCm;
    if (a.wallLengthM != null) c.l = a.wallLengthM;
    if (a.surfaceLengthM != null) c.sl = a.surfaceLengthM;
    if (a.surfaceHeightM != null) c.sh = a.surfaceHeightM;
    if (a.cornerCount != null) c.c = a.cornerCount;
    try {
      return w.btoa(unescape(encodeURIComponent(JSON.stringify(c))))
        .replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
    } catch (e) { return null; }
  }
  function decodeInputs(enc) {
    if (!enc) return null;
    try {
      var b64 = enc.replace(/-/g, "+").replace(/_/g, "/");
      while (b64.length % 4) b64 += "=";
      var c = JSON.parse(decodeURIComponent(escape(w.atob(b64))));
      /* state-Format exakt wie iso-loesung-flow (Strings, calculateFinalAnalysis-kompatibel) */
      var side = c.m === "side";
      var st = {
        moistureType: side ? "side" : "bottom",
        masonryType: c.t || "ziegel",
        cornerCount: String(c.c != null ? c.c : 0),
        wallThickness: String(c.w != null ? c.w : 36),
        variationFaktor: 1
      };
      if (side) { st.surfaceLength = String(c.sl || ""); st.surfaceHeight = String(c.sh || ""); }
      else { st.wallLength = String(c.l || ""); }
      return st;
    } catch (e) { return null; }
  }

  /* ══ Analysis + Links ══ */
  function getAnalysis() {
    try {
      if (w.IsoWiz && w.IsoWiz.Calculations && typeof w.IsoWiz.Calculations.getFinalAnalysis === "function") {
        var a = w.IsoWiz.Calculations.getFinalAnalysis();
        if (a && a.calculatedBottles > 0) return a;
      }
    } catch (e) {}
    try {
      var raw = w.localStorage.getItem("isofinAnalysis");
      if (raw) { var b = JSON.parse(raw); if (b && b.calculatedBottles > 0) return aktionPreisFrisch(b); }
    } catch (e) {}
    return null;
  }
  /* Aktion Paket 2 (04.10.2026, BAULISTE 4.2 Nr. 21): Der Rückfall oben liest den Speicher roh —
     auf Seiten ohne Rechenkern (IsoWiz.Calculations fehlt). In der Aktion, oder wenn die Analyse
     mit Aktionspreis gerechnet wurde (Merker isoAktionPreis), den Preis frisch aus der Flaschenzahl
     ableiten (ISO_AKTION aus layout/theme.liquid). Sonst bleibt das Objekt unberührt. */
  function aktionPreisFrisch(a) {
    try {
      var ak = w.ISO_AKTION, n = Math.floor(Number(a && a.calculatedBottles) || 0);
      if (!ak || typeof ak.istAktiv !== "function" || typeof ak.summeCent !== "function" || n < 1) return a;
      var aktiv = ak.istAktiv();
      if (!aktiv && !a.isoAktionPreis) return a;
      if (w.IsoWiz && w.IsoWiz.Calculations && typeof w.IsoWiz.Calculations.preiseAuffrischen === "function") return w.IsoWiz.Calculations.preiseAuffrischen(a);
      a.unitPrice = ak.stueckpreisCent(n) / 100;
      a.totalPriceIsofin = ak.summeCent(n) / 100;
      if (aktiv) a.isoAktionPreis = ak.aktionBis || "1"; else delete a.isoAktionPreis;
    } catch (e) {}
    return a;
  }
  /* Aktion Paket 2: läuft die Aktion gerade (nicht in der Vorschau-Frage, nur Anzeige/Text) */
  function aktionLaeuft() {
    try { return !!(w.ISO_AKTION && typeof w.ISO_AKTION.istAktiv === "function" && w.ISO_AKTION.istAktiv()); } catch (e) { return false; }
  }
  /* v475: Kanal-Attribution für den Speichern-Link. Der Nutzer sendet den Link
     an sich selbst (WhatsApp/E-Mail/kopiert) und kauft evtl. auf einem anderen
     Gerät — der Link IST der Träger (cookie-unabhängig, geräteübergreifend).
     resumeUrl bekommt &src=save_<kanal>; checkoutUrl bekommt ein Cart-Attribut,
     das bis in die Bestellung durchläuft (im Shopify-Admin/Order sichtbar,
     ohne Custom-Pixel-Code). Bewusst KEINE utm_*, um die Google-Ads-/Meta-
     Attribution der bezahlten Erstklicks nicht zu überschreiben. */
  function resumeUrl(a, channel) {
    var enc = encodeInputs(a);
    if (!enc) return null;
    var u = w.location.origin + KALK_PATH + "?p=" + enc;
    if (channel) u += "&src=save_" + channel;
    if (mitGeraet(channel)) u += "&dev=" + GERAET;
    return u;
  }
  function checkoutUrl(a, channel) {
    var q = Math.max(1, Math.ceil((a && a.calculatedBottles) || 1));
    var u = w.location.origin + "/cart/" + VARIANT_ID + ":" + q;
    if (channel) u += "?attributes[isofin_save_channel]=save_" + channel;
    if (mitGeraet(channel)) u += "&attributes[isofin_save_device]=" + GERAET;
    return u;
  }
  function fmtEuro(v) {
    var n = Number(v) || 0;
    try { return n.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €"; }
    catch (e) { return n.toFixed(2) + " €"; }
  }

  /* ══ Nachrichtentext (WhatsApp + E-Mail-Body) ══ */
  function buildText(a, channel) {
    var side = a.moistureType === "side";
    var L = ["Meine Isofin®-Berechnung", ""];
    L.push("• " + (a.barrierLabel || (side ? "Flächensperre" : "Horizontalsperre")));
    var mauer = a.masonryLabel || a.masonryType || "";
    if (mauer) mauer = mauer.charAt(0).toUpperCase() + mauer.slice(1);
    if (mauer) L.push("• Mauerwerk: " + mauer + (a.wallThicknessCm ? ", " + a.wallThicknessCm + " cm" : ""));
    if (side) {
      if (a.surfaceLengthM != null) L.push("• Fläche: " + a.surfaceLengthM + " m × " + (a.surfaceHeightM != null ? a.surfaceHeightM + " m" : "?"));
    } else if (a.wallLengthM != null) {
      L.push("• Wandlänge: " + a.wallLengthM + " m" + (a.cornerCount ? " · " + a.cornerCount + " Ecken" : ""));
    }
    L.push("• Material: " + (a.calculatedBottles || "?") + " Flaschen" + (a.holeCount ? " · " + a.holeCount + " Bohrlöcher" : ""));
    /* Aktion Paket 2: in der Aktion steht die Frist beim Preis (die Nachricht wird oft erst
       Tage später wieder geöffnet). Außerhalb unverändert. */
    if (a.totalPriceIsofin) L.push("• Materialkosten: " + fmtEuro(a.totalPriceIsofin) + (aktionLaeuft() && w.ISO_AKTION.endeText ? " (Aktionspreis bis " + w.ISO_AKTION.endeText + ")" : ""));
    L.push("");
    /* v550 (Björn 24.09.): Hendrik steht jetzt direkt unter der Berechnung, nicht mehr ganz
       am Ende — „ich will einfach nochmal bestmöglichst einen Support liefern". Wer die
       Nachricht in drei Tagen wieder öffnet, soll die Hilfe sehen, bevor er nach unten scrollt. */
    L.push("Fragen vor, während oder nach der Anwendung? Hendrik Flügge hilft Ihnen persönlich:");
    L.push("📱 0170 844 94 72 (auch WhatsApp)");
    L.push("☎️ 0800 22 66 245 (kostenlos)");
    L.push("✉️ anfrage@isofin.de");
    L.push("");
    var ru = resumeUrl(a, channel);
    if (ru) { L.push("🔗 Meine Berechnung & Bohrplan öffnen:"); L.push(ru); L.push(""); }
    L.push("🛒 Zur Kasse gehen (berechnete Menge):");
    L.push(checkoutUrl(a, channel));
    return L.join("\n");
  }

  /* ═══════════════ TEIL A — Loader-Gate + Restore ═══════════════ */
  var loaderInjected = false;
  function injectLoader() {
    if (loaderInjected || !CFG.loader) return;
    loaderInjected = true;
    var s = d.createElement("script");
    s.src = CFG.loader;
    d.head.appendChild(s);
  }
  function loadScript(src) {
    return new Promise(function (res, rej) {
      var s = d.createElement("script");
      s.src = src; s.async = true;
      s.onload = res;
      s.onerror = function () { rej(new Error("load failed: " + src)); };
      d.head.appendChild(s);
    });
  }
  function ensureIsoWiz() {
    if (w.IsoWiz && w.IsoWiz.Calculations && typeof w.IsoWiz.Calculations.calculateFinalAnalysis === "function") {
      return Promise.resolve();
    }
    return loadScript(CFG.storage)
      .then(function () { return loadScript(CFG.config); })
      .then(function () { return loadScript(CFG.calculations); })
      .then(function () {
        if (!(w.IsoWiz && w.IsoWiz.Calculations && typeof w.IsoWiz.Calculations.calculateFinalAnalysis === "function")) {
          throw new Error("IsoWiz.Calculations fehlt nach Laden");
        }
      });
  }
  function setCartQty(qty) {
    var updates = {};
    updates[VARIANT_ID] = Math.max(1, Math.round(qty));
    return fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { if (!r || !r.ok) throw new Error("cart update failed"); return r.json(); });
  }
  /* v475: Cart-Attribut setzen — überlebt bis in die Bestellung (Order note_attributes),
     im Shopify-Admin sichtbar ohne Custom-Pixel. So trägt JEDER Checkout aus diesem
     Warenkorb den Speichern-Kanal, egal über welchen CTA gekauft wird. */
  function setCartAttribute(key, val) {
    var attrs = {}; attrs[key] = val;
    return setCartAttributes(attrs);
  }
  /* v588: mehrere Attribute in EINEM Aufruf (update.js fuehrt sie zusammen). */
  function setCartAttributes(attrs) {
    return fetch("/cart/update.js", {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }
  function withTimeout(p, ms) {
    return new Promise(function (res, rej) {
      var t = setTimeout(function () { rej(new Error("timeout")); }, ms);
      p.then(function (v) { clearTimeout(t); res(v); }, function (e) { clearTimeout(t); rej(e); });
    });
  }
  function spinner(on, msg) {
    var el = d.getElementById("isowiz-transition-loader");
    if (!el) return;
    if (msg) { var t = el.querySelector(".iw-transition-text"); if (t) t.textContent = msg; }
    el.classList[on ? "add" : "remove"]("is-visible");
  }
  function cleanUrl() {
    try { w.history.replaceState({}, "", w.location.origin + w.location.pathname); } catch (e) {}
  }
  function restoreOrBoot() {
    var enc = null, saveChannel = null, saveDevice = null;
    try {
      var sp = new URLSearchParams(w.location.search);
      enc = sp.get("p");
      /* v475: Kanal-Stempel des Speichern-Links auslesen (save_whatsapp/…). Vor
         cleanUrl merken, damit ein späterer Kauf ihm zugeordnet werden kann. */
      var src = sp.get("src");
      if (src && src.indexOf("save_") === 0) {
        saveChannel = src;
        try { w.localStorage.setItem("__ISO_SAVE_CHANNEL__", src); } catch (e) {}
        try { w.localStorage.setItem("__ISO_SAVE_CHANNEL_TS__", String(Date.now())); } catch (e) {}
      }
      /* v588: Geraet beim Speichern (nur mit Kanal-Stempel, nur bekannte Werte). */
      var dev = sp.get("dev");
      if (saveChannel && saveChannel !== "save_rueckruf" && dev && GERAETE_RE.test(dev)) saveDevice = dev;
    } catch (e) {}
    /* v588: Logr3 liefert keine Nutzlast — der Wechsel steht deshalb im Namen,
       z. B. ergebnis_restore_geraet_mobil_desktop. Gesendet beim OEFFNEN des Links,
       nicht erst nach geglueckter Wiederherstellung (der Wechsel ist dann schon passiert). */
    function geraeteWechsel(art) {
      if (saveDevice && GERAET) { try { track("ergebnis_" + art + "_geraet_" + saveDevice + "_" + GERAET, {}); } catch (e) {} }
    }
    if (!enc) {
      /* Kanal auch ohne ?p= (falls nur der Checkout-Link geöffnet wurde) merken. */
      if (saveChannel) {
        try { track("ergebnis_save_return", { src: saveChannel, geraet_speichern: saveDevice }); } catch (e) {}
        /* B9: welcher Speicherweg bringt die Leute zurueck? */
        try { track("ergebnis_save_return_" + String(saveChannel).replace("save_", "")); } catch (e) {}
        geraeteWechsel("save_return");
      }
      injectLoader(); return;
    }
    geraeteWechsel("restore");
    var state = decodeInputs(enc);
    if (!state) { cleanUrl(); injectLoader(); return; }
    spinner(true, "Ihre gespeicherte Berechnung wird geöffnet …");
    withTimeout(
      ensureIsoWiz().then(function () {
        var analysis = w.IsoWiz.Calculations.calculateFinalAnalysis(state);
        if (!analysis || !(analysis.calculatedBottles > 0)) throw new Error("analysis leer");
        try { if (w.IsoWiz.Storage && w.IsoWiz.Storage.set) w.IsoWiz.Storage.set("state", state); } catch (e) {}
        try { w.sessionStorage.setItem("__ISOWIZ_RESUME_ANALYSIS__", JSON.stringify(analysis)); } catch (e) {}
        return setCartQty(analysis.calculatedBottles).then(function () {
          if (saveChannel) {
            /* v588: Speicher- und Oeffnungsgeraet mit in die Bestellung. Der Warenkorb
               gehoert zu DIESEM Browser — wer hier kauft, kauft also auf dem
               Oeffnungsgeraet. Shopify selbst gibt das Geraet einer Bestellung nicht heraus. */
            /* Immer alle drei schreiben: update.js fuehrt zusammen und loescht nichts —
               sonst blieben Geraete eines frueheren Links stehen. Shopify behaelt einen
               leeren Wert als leeres Merkmal: leer = Link ohne Geraeteangabe (alt/Rueckruf). */
            var at = { isofin_save_channel: saveChannel, isofin_save_device: saveDevice || "",
              isofin_open_device: saveDevice && GERAET ? GERAET : "" };
            return setCartAttributes(at).then(function () { return analysis; });
          }
          return analysis;
        });
      }).then(function (analysis) {
        try { w.sessionStorage.setItem("__ISOWIZ_START_INTENT__", JSON.stringify({ targetStep: "step-4", source: "ergebnis-share" })); } catch (e) {}
        track("ergebnis_restore", { bottles: analysis.calculatedBottles, src: saveChannel || "direct", geraet_speichern: saveDevice });
        try { track("ergebnis_restore_" + String(saveChannel || "direct").replace("save_", "")); } catch (e) {}
      }),
      12000
    ).then(function () {
      cleanUrl(); injectLoader();
    }).catch(function (err) {
      track("ergebnis_restore_error", { msg: String((err && err.message) || err).slice(0, 80) });
      cleanUrl(); spinner(false); injectLoader();
    });
  }

  /* ═══════════════ TEIL B — Speicher-UI auf step-4 ═══════════════ */
  var CSS = "" +
    ".ies-row{max-width:460px;margin:18px auto 6px;padding:0 16px;box-sizing:border-box}" +
    /* v525 (Bjoern 09.09.): Der zweite E-Mail-Block stand unten als volle Reihe und
       wiederholte den oberen 1:1 — 424 px allein dafuer. Bjoern: "das zerreisst und macht
       die Seite so krass lang". Jetzt ein Aufklapp-Knopf; die Reihe kommt erst auf Klick. */
    ".ies-fold{max-width:460px;margin:14px auto 8px;padding:0 16px;box-sizing:border-box}" +
    ".ies-fold-btn{display:flex;align-items:center;justify-content:center;gap:10px;width:100%;" +
      "min-height:52px;padding:13px 16px;background:#fff;color:#D6001C;border:1.5px solid #D6001C;" +
      "border-radius:12px;font-family:Rubik,system-ui,sans-serif;font-size:15px;font-weight:700;" +
      "cursor:pointer;-webkit-tap-highlight-color:transparent;line-height:1.3;text-align:center}" +
    ".ies-fold-btn:hover{background:#D6001C;color:#fff}" +
    ".ies-fold-ic{display:inline-flex;align-items:center;justify-content:center;width:22px;height:22px;" +
      "border-radius:50%;background:#D6001C;color:#fff;font-size:10px;line-height:1;flex:none;transition:transform .18s ease}" +
    ".ies-fold-btn:hover .ies-fold-ic{background:#fff;color:#D6001C}" +
    ".ies-fold.is-on .ies-fold-ic{transform:rotate(180deg)}" +
    ".ies-fold-body{display:none}" +
    ".ies-fold.is-on .ies-fold-body{display:block}" +
    ".ies-fold.is-on .ies-fold-btn{border-radius:12px 12px 0 0;border-bottom-color:transparent}" +
    ".ies-save{width:100%;display:flex;align-items:center;justify-content:center;gap:10px;padding:15px 20px;box-sizing:border-box;background:#fff !important;border:2px solid #D6001C !important;border-radius:12px;color:#D6001C !important;font-family:Rubik,-apple-system,sans-serif !important;font-size:16px !important;font-weight:700 !important;line-height:1.3 !important;cursor:pointer;-webkit-tap-highlight-color:transparent;transition:background .15s,color .15s}" +
    ".ies-save:hover{background:#D6001C !important;color:#fff !important}" +
    ".ies-sub{margin:8px 0 0;text-align:center;font-family:Rubik,-apple-system,sans-serif !important;font-size:13px !important;color:#6b6b6b !important;line-height:1.4 !important}" +
    /* v521 (Bjoern 07.09.): E-Mail-Feld direkt auf der Ergebnisseite statt Knopf -> Schublade -> Feld */
    ".ies-inline{max-width:520px;background:#fff;border:1px solid #e8e6e2;border-radius:14px;padding:16px !important;box-shadow:0 2px 10px rgba(0,0,0,.04);font-family:Rubik,-apple-system,sans-serif}" +
    /* v525: linksbündig, Kopf mit Symbolspalte, Feld über Knopf. */
    ".ies-inline{text-align:left}" +
    ".ies-inl-head{display:grid;grid-template-columns:26px 1fr;gap:9px;align-items:start;margin:0 0 4px}" +
    ".ies-inl-ic{font-size:19px;line-height:1.15}" +
    ".ies-inl-ttl{margin:0;font-size:16px;font-weight:700;color:#111;line-height:1.28;letter-spacing:-.01em}" +
    ".ies-inl-hint{margin:0 0 12px;font-size:13.5px;color:#474747;line-height:1.5}" +
    ".ies-inl-lab{display:block;font-size:13px;letter-spacing:.07em;text-transform:uppercase;font-weight:700;color:#8a8a8a;margin:0 0 5px}" +
    ".ies-inl-row{display:flex;flex-direction:column;gap:9px}" +
    ".ies-inl-addr{width:100%;min-width:0;padding:13px 14px;border:1.5px solid #e0e0e0;border-radius:11px;font-size:16px;font-family:inherit;color:#111;background:#fff;box-sizing:border-box;min-height:50px}" +
    ".ies-inl-addr::placeholder{color:#9a9a9a}" +
    ".ies-inl-addr:focus{outline:none;border-color:#1565C0;box-shadow:0 0 0 3px rgba(21,101,192,.14)}" +
    /* v525.5 (Björn 09.09.): „ob man den Button vielleicht blau macht, weil das
       irgendwie mehr an E-Mail erinnert und nicht rot wie bei der Webseite alle."
       Genau richtig: Markenrot heißt auf dieser Seite „in die Kasse". Ein roter
       Senden-Knopf konkurriert optisch mit dem Kauf-Button, obwohl er etwas ganz
       anderes tut. Blau trennt die beiden Absichten sauber — und ist die Farbe,
       die man mit Post und Nachrichten verbindet.
       #1565C0 ist dunkel genug für weiße Schrift (Kontrast 5,6:1). */
    ".ies-inl-go{width:100%;background:#1565C0;color:#fff;border:0;border-radius:11px;padding:14px;font-size:16px;font-weight:700;font-family:inherit;cursor:pointer;min-height:52px}" +
    ".ies-inl-go:hover{background:#0D47A1}.ies-inl-go:disabled{opacity:.6;cursor:default}" +
    /* v577: schlanke Karte – am Rechner Feld und Knopf nebeneinander, volle Inhaltsbreite; Vorlese-Beschriftung */
    ".ies-sr{position:absolute !important;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0}" +
    ".ies-inline .ies-inl-head{margin:0 0 10px}" +
    "@media (min-width:600px){.ies-inline .ies-inl-row{flex-direction:row;align-items:stretch}.ies-inline .ies-inl-row .ies-inl-addr{flex:1 1 auto}.ies-inline .ies-inl-row .ies-inl-go{width:auto;flex:0 0 auto;padding:0 26px;min-height:50px}}" +
    "#isowiz-step4-root .isocal-s6v2-content>#ies-top.ies-inline{max-width:760px !important}" +
    ".ies-inline .ies-inl-erk:not(:empty){margin:8px 0 0}" +
    ".ies-inline .ies-consent{padding:10px 12px;margin:10px 0 0}" +
    /* v528: auf sehr schmalen Geraeten (320px) brach die neue Beschriftung auf
       zwei Zeilen. Eine Stufe kleiner haelt sie einzeilig und bleibt ueber der
       13px-Grenze fuer die Zielgruppe 45+. */
    "@media (max-width:359px){.ies-inl-go{font-size:14.5px;padding:14px 8px}}" +
    ".ies-inl-err{display:none;margin:6px 0 0;font-size:13px;color:#D6001C}.ies-inl-err.is-on{display:block}" +
    ".ies-inline .ies-consent{margin:12px 0 0;padding:0}" +
    /* v525: „Andere Wege" unter einer Trennlinie statt zentriert als Kleingedrucktes. */
    ".ies-inl-alt{margin:12px 0 0;padding:10px 0 0;border-top:1px solid #e5e5e5;font-size:13.5px;color:#474747;text-align:left;line-height:1.45}" +
    /* v525.5: „Andere Wege" gehört zum E-Mail-Block, also auch Blau — ein roter
       Link mitten in einem blauen Formular liest sich wie ein Kauf-Weg. */
    ".ies-inl-altbtn{background:none;border:0;padding:0;font:inherit;color:#1565C0;text-decoration:underline;cursor:pointer;min-height:24px}" +
    /* v525: die Einwilligung ist rechtlich der Nachweis — sie gehört in eine
       eigene Karte mit 24-px-Kästchen, nicht in eine graue Fußnote. */
    ".ies-inline .ies-consent{display:grid;grid-template-columns:24px 1fr;gap:10px;margin:13px 0 0;" +
      "padding:12px;background:#F0F9F2;border:1px solid #CDE8D4;border-radius:11px;cursor:pointer;align-items:start}" +
    ".ies-inline .ies-consent input{width:24px;height:24px;margin:1px 0 0;accent-color:#1E7A34}" +
    ".ies-inline .ies-consent .ies-consent-lead{font-size:13.5px;line-height:1.45}" +
    ".ies-inline .ies-consent .ies-consent-small{font-size:13px;color:#474747;line-height:1.45;margin-top:6px}" +
    ".ies-ov{position:fixed;inset:0;background:rgba(17,17,17,.45);z-index:2147483200;opacity:0;visibility:hidden;transition:opacity .18s}" +
    ".ies-ov.is-on{opacity:1;visibility:visible}" +
    /* v588: Dawn blendet leere divs aus (base.css div:empty{display:none}) – Abdunklung sonst nie sichtbar */
    ".ies-ov.ies-ov{display:block}" +
    ".ies-sheet{position:fixed;left:0;right:0;bottom:0;z-index:2147483201;background:#fff;border-radius:18px 18px 0 0;padding:20px 18px calc(18px + env(safe-area-inset-bottom));box-shadow:0 -8px 30px rgba(0,0,0,.18);transform:translateY(105%);visibility:hidden;pointer-events:none;transition:transform .22s ease,visibility 0s linear .22s;max-height:86vh;overflow:auto;font-family:Rubik,-apple-system,sans-serif}" +
    /* v421: visibility/pointer-events — das geschlossene Sheet lag auf Desktop
       als UNSICHTBARER Klick-Blocker (nur opacity:0) mitten im Viewport und
       fraß alle Klicks (»Speichern hängt sich auf«). Desktop jetzt außerdem
       als Boden-Schublade statt Mittel-Modal (Björns Wunsch). */
    ".ies-sheet.is-on{transform:translateY(0);visibility:visible;pointer-events:auto;transition:transform .22s ease}" +
    "@media(min-width:768px){.ies-sheet{left:50%;right:auto;width:440px;transform:translate(-50%,105%)}.ies-sheet.is-on{transform:translate(-50%,0)}}" +
    ".ies-head{display:flex;align-items:flex-start;justify-content:space-between;gap:10px;margin:0 0 4px}" +
    ".ies-title{margin:0;font-size:19px;font-weight:700;color:#1a1a1a}" +
    ".ies-x{flex:0 0 auto;width:44px;height:44px;border:1px solid #e4e0d9;border-radius:50%;background:#fff;color:#1a1a1a;font-size:20px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0}.ies-x:hover{background:#f2f1ef}.ies-x:focus-visible{outline:3px solid #D6001C;outline-offset:2px}" +
    ".ies-note{margin:0 0 14px;font-size:14px;color:#6b6b6b;line-height:1.45}" +
    ".ies-opt{width:100%;display:flex;align-items:center;gap:12px;padding:15px 14px;box-sizing:border-box;background:#faf9f8;border:1px solid #e8e6e2;border-radius:12px;margin:0 0 10px;font-size:16px;font-weight:600;color:#1a1a1a;cursor:pointer;text-align:left;text-decoration:none;font-family:inherit}" +
    ".ies-opt:hover{border-color:#d0cdc8}" +
    ".ies-opt .ies-ic{flex:0 0 auto;font-size:20px}" +
    ".ies-foot{margin:8px 0 0;font-size:12.5px;color:#8a8a8a;line-height:1.45;text-align:center}" +
    ".ies-wa{display:none;background:#faf9f8;border:1px solid #e8e6e2;border-radius:12px;padding:14px;margin:0 0 10px}" +
    ".ies-wa.is-on{display:block}" +
    ".ies-wa label{display:block;font-size:13px;font-weight:600;color:#444;margin:0 0 6px}" +
    ".ies-wa-row{display:flex;gap:8px}" +
    ".ies-wa input{flex:1;height:48px;padding:0 12px;font-size:16px;border:1px solid #d6d3ce;border-radius:10px;box-sizing:border-box;font-family:inherit}" +
    ".ies-wa-go{flex:0 0 auto;height:48px;padding:0 16px;background:#1d7a3d;border:0;border-radius:10px;color:#fff;font-size:15px;font-weight:700;cursor:pointer;font-family:inherit}" +
    ".ies-wa-err{display:none;margin:6px 0 0;font-size:12.5px;color:#c62828}" +
    ".ies-wa-err.is-on{display:block}" +
    ".ies-mail-go{background:#D6001C}" +
    /* v27.22.0: Hinweiszeile, freiwilliges Kaestchen (Tap-Ziel 44 px), Erfolgsmeldung */
    ".ies-mail-info{margin:8px 0 0;font-size:12.5px;color:#6b6b6b;line-height:1.45}" +
    ".ies-consent{display:flex;align-items:flex-start;gap:10px;margin:10px 0 0;padding:6px 0;cursor:pointer}" +
    ".ies-consent input{flex:0 0 auto;width:22px;height:22px;margin:1px 0 0;accent-color:#1d7a3d}" +
    ".ies-consent span{font-size:13.5px;color:#444;line-height:1.4;font-weight:400}" +
    ".ies-consent .ies-consent-lead{display:block;font-size:14px;font-weight:700;color:#111;line-height:1.4}" +
    ".ies-consent .ies-consent-small{display:block;font-size:13px;color:#555;line-height:1.4;margin-top:3px}" +
    ".ies-mail-ok{display:none;margin:10px 0 0;padding:10px 12px;background:#eaf3de;border:1px solid #c0dd97;border-radius:10px;color:#27500a;font-size:14px;font-weight:600;line-height:1.4}" +
    ".ies-mail-ok.is-on{display:block}" +
    /* v550: Erkennungszeile, Rückruf-Kasten, Zusatzfeld, Fehlerfall */
    ".ies-inl-erk{margin:0;min-height:0;font-size:14px;line-height:1.45;color:#474747}" +
    ".ies-inl-erk:empty{display:none}" +
    ".ies-inl-erk.is-ok{color:#1E7A34;font-weight:600}" +
    ".ies-inl-erk.is-hinweis{color:#8a5a00;background:#fff7e6;border:1px solid #f3d9a4;border-radius:9px;padding:8px 10px}" +
    ".ies-rr{margin:14px 0 0;padding:12px 12px;border:1.5px solid #cfe3cf;background:#f4faf4;border-radius:11px}" +
    /* v573 (Adrian 29.09.: „oben das weg – nur unten Hendrik beim Akkordeon mit Bild“): Die kompakte
       Hendrik-Karte (bis 1.000 €) direkt über dem Speicherfeld wird ausgeblendet; Hendrik steht nur noch
       als Aufklapp-Zeile mit Porträt im Speicherfeld (Rückruf + Telefon/WhatsApp). Nur Gestaltung, die
       Karte gehört dem Rechner (sec-01). Großprojekte und Hohlblock behalten ihren Hendrik-Kasten. */
    "#isowiz-step4-root .isocal-s6v2-content>.isocal-s6v2-hendrik-platz:has(>.isocal-s6v2-hk):has(~#ies-top){display:none !important}" +
    ".ies-rr-sum .ies-rr-sumfoto{width:40px;height:40px;border-radius:50%;object-fit:cover;border:2px solid #D6001C;flex:0 0 auto;background:#e6efe6}" +
    ".ies-rr-sum .ies-rr-sumtxt{flex:1 1 auto;min-width:0;display:block;font-size:14.5px;font-weight:700;color:#111;line-height:1.3}" +
    ".ies-rr-sum .ies-rr-sumtxt span{display:block;font-size:13.5px;font-weight:500;color:#1E5E2A;margin-top:2px}" +
    ".ies-rr-auf .ies-rr-kopf{grid-template-columns:1fr}.ies-rr-auf .ies-rr-foto{display:none}" +
    ".ies-rr-direkt{margin:12px 0 0;padding:10px 0 0;border-top:1px solid #d6e8d6;font-size:14px;color:#333;line-height:1.5}" +
    ".ies-rr-direkt a{color:#1565C0;font-weight:700;text-decoration:underline;white-space:nowrap}" +
    /* v572: Rückruf-Kasten zugeklappt – eine ruhige Zeile mit Pfeil, aufgeklappt wie bisher. */
    ".ies-rr-auf{margin:12px 0 0}" +
    ".ies-rr-sum{display:flex;align-items:center;justify-content:space-between;gap:11px;min-height:44px;padding:10px 12px;border:1.5px solid #cfe3cf;background:#f4faf4;border-radius:11px;font-size:14.5px;font-weight:600;color:#1E5E2A;line-height:1.35;cursor:pointer;list-style:none}" +
    ".ies-rr-sum::-webkit-details-marker{display:none}" +
    ".ies-rr-sum::after{content:\"\\25BE\";font-size:15px;color:#1E7A34;flex:0 0 auto}" +
    ".ies-rr-auf[open] .ies-rr-sum::after{content:\"\\25B4\"}" +
    ".ies-rr-auf[open] .ies-rr-sum{border-bottom:0;border-radius:11px 11px 0 0}" +
    ".ies-rr-sum:focus-visible{outline:3px solid #1565C0;outline-offset:2px}" +
    ".ies-rr-auf .ies-rr{margin:0;border-top:0;border-radius:0 0 11px 11px}" +
    ".ies-rr-kopf{display:grid;grid-template-columns:44px 1fr;gap:11px;align-items:center;margin:0 0 11px;padding:0 0 11px;border-bottom:1px solid #d6e8d6}" +
    ".ies-rr-foto{width:44px;height:44px;border-radius:50%;object-fit:cover;display:block;background:#e6efe6}" +
    ".ies-rr-ttl{margin:0;font-size:15.5px;font-weight:700;color:#111;line-height:1.3}" +
    ".ies-rr-ttl span{display:block;font-size:13.5px;font-weight:400;color:#474747;margin-top:2px}" +
    ".ies-rr-lab{display:grid;grid-template-columns:24px 1fr;gap:10px;cursor:pointer;margin:0}" +
    ".ies-rr-lab input{width:24px;height:24px;margin:1px 0 0;accent-color:#1E7A34}" +
    ".ies-rr-lead{display:block;font-size:15px;font-weight:700;color:#111;line-height:1.4}" +
    ".ies-rr-small{display:block;font-size:13.5px;color:#474747;line-height:1.45;margin-top:5px}" +
    ".ies-rr-small a{color:#1565C0}" +
    ".ies-rr-telwrap{display:none;margin:12px 0 0}.ies-rr-telwrap.is-on{display:block}" +
    ".ies-rr-tel{width:100%;min-width:0;padding:13px 14px;border:1.5px solid #e0e0e0;border-radius:11px;font-size:16px;font-family:inherit;color:#111;background:#fff;box-sizing:border-box;min-height:50px}" +
    ".ies-rr-tel:focus{outline:none;border-color:#1565C0;box-shadow:0 0 0 3px rgba(21,101,192,.14)}" +
    ".ies-rr-err{display:none;margin:6px 0 0;font-size:13.5px;color:#D6001C}.ies-rr-err.is-on{display:block}" +
    ".ies-mail-ok a{color:#27500a;text-decoration:underline}" +
    ".ies-mail-ok.is-fehler{background:#fff4f4;border-color:#f3c1c1;color:#7a1f1f}.ies-mail-ok.is-fehler a{color:#B8001A}" +
    /* v588: Ergebnisseiten-Karte im Speichern-Fenster – ohne zweiten Rahmen und zweiten Titel. */
    ".ies-sheet .ies-sheet-karte{margin:0 0 12px}" +
    ".ies-sheet .ies-inline{max-width:none;border:0;box-shadow:none;padding:0 !important;background:transparent}" +
    ".ies-sheet .ies-inline .ies-inl-head{display:none}" +
    /* v588: zwei gleich große Karten, klar getrennt. Speichern blau, Hendrik grün. */
    ".ies-sheet .ies-rr-auf{display:none !important}" +
    ".ies-sheet .ies-inline .ies-consent .ies-consent-lead,.ies-sheet .ies-inline .ies-consent .ies-consent-small{font-size:15px}" +
    ".ies-sheet--split .ies-head{position:sticky;top:-20px;z-index:3;background:#fff;margin:-20px -18px 4px;padding:16px 18px 8px}" +
    ".ies-sheet--split .ies-x{width:48px;height:48px}" +
    ".ies-k-sprung{display:flex;align-items:center;justify-content:center;gap:6px;width:100%;min-height:48px;margin:6px 0 0;padding:10px 12px;box-sizing:border-box;background:#f1f8f2;border:2px solid #c7e3cd;border-radius:12px;font-size:15px;font-weight:700;color:#14713a;font-family:inherit;cursor:pointer;text-align:center}" +
    ".ies-split{display:flex;flex-direction:column;gap:0;margin:10px 0 0}" +
    ".ies-k{display:flex;flex-direction:column;gap:10px;border-radius:16px;padding:16px;box-sizing:border-box}" +
    ".ies-k-save{background:#f4f8fd;border:2px solid #c9dcf3}" +
    ".ies-k-hendrik{background:#f1f8f2;border:2px solid #c7e3cd}" +
    ".ies-k-ttl{margin:0;font-size:18px;font-weight:700;color:#1a1a1a;line-height:1.3}" +
    ".ies-k-txt{margin:0;font-size:15px;color:#3f3f3f;line-height:1.45}" +
    ".ies-k-name{margin:2px 0 0;font-size:15px;color:#2f6b3a;font-weight:600;line-height:1.35}" +
    ".ies-k-kopf{display:flex;align-items:center;gap:12px}" +
    ".ies-k-foto{width:64px;height:64px;border-radius:50%;border:3px solid #D6001C;object-fit:cover;flex:0 0 auto}" +
    ".ies-k .ies-sheet-karte{margin:0}" +
    ".ies-k-copy{margin:0;background:#fff}" +
    ".ies-k-btn{display:flex;align-items:center;justify-content:center;gap:8px;min-height:50px;padding:12px 14px;box-sizing:border-box;border-radius:12px;font-size:16px;font-weight:700;text-decoration:none;cursor:pointer;font-family:inherit;width:100%;border:0}" +
    ".ies-k-wege{display:flex;flex-direction:column;gap:10px}" +
    ".ies-k-tel{background:#D6001C;color:#fff}.ies-k-tel:hover{background:#B8001A}" +
    ".ies-k-wa{background:#fff;color:#14713a;border:2px solid #25D366}.ies-k-wa:hover{background:#f3fcf6}" +
    ".ies-k-walogo{flex:0 0 auto}" +
    ".ies-k-rrblock{display:flex;flex-direction:column;gap:10px}" +
    ".ies-k-rr{background:#fff;color:#D6001C;border:2px solid #D6001C}.ies-k-rr:hover{background:#fff5f6}" +

    /* außerhalb der Servicezeit: der oberste Weg (Rückruf) ist der gefüllte, Anrufen nur umrahmt */
    ".ies-k-hendrik.is-zu .ies-k-rr{background:#D6001C;color:#fff}.ies-k-hendrik.is-zu .ies-k-rr:hover{background:#B8001A}" +
    ".ies-k-hendrik.is-zu .ies-k-tel{background:#fff;color:#D6001C;border:2px solid #D6001C}" +
    ".ies-k-punkt{display:inline-block;width:9px;height:9px;border-radius:50%;background:#2e9e4a;margin:0 6px 1px 0;vertical-align:middle}" +
    ".ies-k-rrfeld{display:none}.ies-k-rrfeld.is-on{display:block}" +
    ".ies-k-lab{display:block;font-size:15px;font-weight:600;color:#1a1a1a;margin:0 0 6px}" +
    ".ies-k-rrzeile{display:flex;flex-direction:column;gap:8px}" +
    ".ies-k-rrzeile input{height:50px;padding:0 12px;font-size:16px;border:1px solid #cfd8d1;border-radius:11px;box-sizing:border-box;font-family:inherit;width:100%}" +
    ".ies-k-rrgo{min-height:50px;background:#D6001C;color:#fff;border:0;border-radius:11px;font-size:16px;font-weight:700;cursor:pointer;font-family:inherit}" +
    ".ies-k-err{display:none;margin:6px 0 0;font-size:14px;color:#c62828}.ies-k-err.is-on{display:block}" +
    ".ies-k-hinweis{margin:8px 0 0;font-size:15px;color:#555;line-height:1.45}.ies-k-hinweis a{color:#2f6b3a}" +
    ".ies-k-ok{margin:0}" +
    ".ies-k-zeit{margin:0;font-size:15px;color:#2f2f2f;line-height:1.45}" +
    ".ies-k-oder{display:flex;align-items:center;gap:10px;margin:12px 0;font-size:15px;font-weight:600;color:#8a857e;text-transform:uppercase;letter-spacing:.06em}" +
    ".ies-k-oder:before,.ies-k-oder:after{content:'';flex:1;height:1px;background:#e2ddd6}" +
    "@media(min-width:768px){.ies-sheet.ies-sheet--split{width:min(820px,calc(100vw - 40px))}" +
      ".ies-split{display:grid;grid-template-columns:1fr auto 1fr;align-items:stretch}" +
      ".ies-k-oder{flex-direction:column;margin:0 12px;writing-mode:horizontal-tb}" +
      ".ies-k-oder:before,.ies-k-oder:after{width:1px;height:auto;flex:1}" +
      ".ies-sheet .ies-inline .ies-inl-row{flex-direction:column}.ies-sheet .ies-inline .ies-inl-row .ies-inl-go{width:100%}" +
      ".ies-k-rrzeile{flex-direction:column}" +
      ".ies-k-sprung{display:none}}";

  function injectCSS() {
    if (d.getElementById("ies-css")) return;
    var s = d.createElement("style");
    s.id = "ies-css";
    s.textContent = CSS;
    d.head.appendChild(s);
  }

  /* v424 (Björn): ALLE Schreibweisen der Handynummer abfangen — die
     Zielgruppe tippt 0049…, +49…, +49 (0)170…, 0170…, 170… mit Leerzeichen,
     Punkten, Schrägstrichen oder Klammern. Alles → wa.me-Format (49…).
     Absicherung: deutsche Nummern müssen wie eine Mobilnummer aussehen
     (15x/16x/17x, 10–11 Ziffern nach der 49), sonst Fehlermeldung statt
     kaputtem WhatsApp-Link. Andere Länder (+43/+41 …) bleiben erlaubt,
     wenn die Vorwahl ausdrücklich mit + oder 00 angegeben wurde. */
  function normPhone(v) {
    var raw = String(v || "");
    var hadCC = /^\s*\+/.test(raw);
    var n = raw.replace(/\D/g, "");
    if (!n) return null;
    if (!hadCC && n.indexOf("00") === 0) { n = n.slice(2); hadCC = true; }
    if (hadCC) {
      /* "+49 (0)170…" / "0049 0170…" — die Klammer-Null nach der
         Ländervorwahl gehört nicht in die Nummer */
      if (n.indexOf("490") === 0 && n.length >= 12) n = "49" + n.slice(3);
    } else if (n.charAt(0) === "0") {
      n = "49" + n.slice(1);
    } else if (n.indexOf("49") === 0 && n.length >= 12) {
      if (n.indexOf("490") === 0 && n.length >= 13) n = "49" + n.slice(3);
    } else {
      n = "49" + n; /* "170 8449472" — führende 0 vergessen */
    }
    if (n.indexOf("49") === 0) {
      return /^1[5-7]\d{8,9}$/.test(n.slice(2)) ? n : null;
    }
    return /^\d{10,15}$/.test(n) ? n : null;
  }
  /* v424: E-Mail-Adresse prüfen (streng genug für mailto: — keine ?&#-Zeichen) */
  function normMail(v) {
    var m = String(v || "").trim();
    return /^[A-Za-z0-9._%+\-äöüÄÖÜß]+@[A-Za-z0-9.\-äöüÄÖÜß]+\.[A-Za-zäöüÄÖÜ]{2,}$/.test(m) ? m : null;
  }
  /* v424: zuletzt genutzte Nummer/Adresse merken — die Zielgruppe soll beim
     nächsten Speichern nicht neu tippen müssen (nur lokal auf dem Gerät) */
  /* v551 (25.09.2026): Kein Vorausfüllen mehr. E-Mail-Adresse oder Handynummer auf dem
     Gerät zu speichern, nur damit das Feld beim nächsten Besuch gefüllt ist, bräuchte nach
     § 25 TDDDG eine Einwilligung (Prüfung Datenschutz 5.6). Beide Funktionen bleiben als
     leere Hüllen, damit keine Aufrufstelle bricht; alte Einträge werden einmal entfernt. */
  function remember(key, val) {}
  function recall(key) { return ""; }
  try { w.localStorage.removeItem("__IES_MAIL_ADDR__"); w.localStorage.removeItem("__IES_WA_NUM__"); } catch (eLS) {}

  /* ═══ v550 (Björn 24.09.): EIN Feld für E-Mail ODER Telefonnummer ═══════════════
     „Man muss das so bauen, dass es für die Zielgruppe 45+ am einfachsten zu verstehen
     ist." Enthält die Eingabe ein @, ist es eine E-Mail. Sonst wird sie als Nummer
     gelesen — in JEDER üblichen Schreibweise: +49 (0) 170 …, 0049 170 …, 0170/…,
     (0170) …, „Tel.: …", vergessene Null, Festnetz mit 2- bis 5-stelliger Vorwahl,
     Österreich, Schweiz. Getestet mit 33 Fällen:
     AENDERUNGEN/2026-09-24_speichern-mit-rueckruf/pruefe-erkennung.js
     normPhone() oben bleibt unverändert — sie gehört der Schublade und lässt nur
     Handynummern zu. Für den Rückruf reicht auch Festnetz, deshalb eine eigene Prüfung. */
  function nurZiffern(s) { return String(s || "").replace(/\D+/g, ""); }
  function leseNummer(eingabe) {
    var roh = String(eingabe || "").trim();
    if (!roh) return { typ: "leer" };
    var plus = /^\s*(?:[A-Za-zäöüÄÖÜ.:\s]*)\+/.test(roh);
    var n = nurZiffern(roh);
    if (n.length < 6) return { typ: "ungueltig" };
    if (plus) { /* bereits international */ }
    else if (n.indexOf("00") === 0) n = n.slice(2);
    else if (n.charAt(0) === "0") n = "49" + n.slice(1);
    else if (/^1[5-7]\d{8,9}$/.test(n)) n = "49" + n;
    else if (!/^(49|43|41)\d{7,13}$/.test(n)) n = "49" + n;
    n = n.replace(/^(49|43|41)0/, "$1");
    var typ = "ungueltig";
    if (n.indexOf("49") === 0) {
      if (/^491[5-7]\d{8,9}$/.test(n)) typ = "mobil";
      else if (/^49[2-9]\d{5,11}$/.test(n)) typ = "festnetz";
    } else if (n.indexOf("43") === 0) {
      if (/^436[5-9]\d{6,10}$/.test(n)) typ = "mobil";
      else if (/^43[1-9]\d{4,12}$/.test(n)) typ = "festnetz";
    } else if (n.indexOf("41") === 0) {
      if (/^417[5-9]\d{7}$/.test(n)) typ = "mobil";
      else if (/^41[1-9]\d{7,8}$/.test(n)) typ = "festnetz";
    } else if (/^[1-9]\d{7,14}$/.test(n)) typ = "ausland";
    if (typ === "ungueltig") return { typ: "ungueltig" };
    return { typ: typ, e164: n, anzeige: anzeigeNummer(n, roh), whatsapp: typ === "mobil" || typ === "ausland" };
  }
  /* Deutsche Handynummern einheitlich, alles andere in der Gruppierung des Kunden —
     Festnetz-Vorwahlen (030, 089, 07531) lassen sich ohne Verzeichnis nicht sicher trennen. */
  function anzeigeNummer(n, roh) {
    if (/^491[5-7]\d{8,9}$/.test(n)) { var nat = "0" + n.slice(2); return nat.slice(0, 4) + " " + nat.slice(4); }
    var t = String(roh || ""), ab = t.search(/[+\d(]/);
    t = ab > 0 ? t.slice(ab) : t;
    t = t.replace(/\(\s*0\s*\)/g, " ").replace(/[()\/.\-]+/g, " ").replace(/\s+/g, " ").trim();
    t = t.replace(/^(\+|00)\s*49\s*0?\s*/, "0").replace(/^00\s*/, "+");
    if (/^\+?\d/.test(t) && t.replace(/\D/g, "").length >= 6) return t;
    return n.indexOf("49") === 0 ? "0" + n.slice(2) : "+" + n;
  }
  function erkenneKontakt(eingabe) {
    var s = String(eingabe || "");
    if (!s.trim()) return { art: "leer" };
    if (s.indexOf("@") !== -1) { var m = normMail(s); return m ? { art: "mail", wert: m } : { art: "mail_unfertig" }; }
    if (nurZiffern(s).length < 6) return { art: "unklar" };
    var nr = leseNummer(s);
    return nr.typ === "ungueltig" ? { art: "nummer_unfertig" } : { art: "nummer", nummer: nr };
  }

  /* ═══ v550: Rückrufbitte — derselbe Weg wie das bewährte Rückrufformular ═════════
     Ziel ist dieselbe Stelle wie /pages/rueckruf-anfragen: ein Shopify-Kontaktformular,
     die Mail geht ins Isofin-Postfach. Dieselben Feldnamen, damit Hendrik die Anfrage so
     sieht, wie er sie kennt — nur mit der kompletten Berechnung dazu.

     Der Shop hat hCaptcha für Kontaktformulare eingeschaltet. Ein nackter fetch auf
     /contact trägt keine Freigabe und endet auf /challenge. Darum wird ein echtes Formular
     ins Dokument gehängt und das submit-Ereignis ausgelöst: Der Bot-Schutz holt die
     Freigabe und ruft f.submit() — das übernehmen wir und senden per fetch MIT Freigabe.
     Kein Seitenwechsel; return_to /cart.js ist eine winzige Antwort ohne Theme und ohne
     Messdienste, an ihrer Adresse erkennen wir den Erfolg.

     Scheitert es (Challenge, Zeitüberschreitung), sieht der Kunde sofort die direkten
     Nummern. Eine Rückrufbitte geht nie still verloren. */
  var RR_VERSION = "2026-09-25 v551";
  var RR_TEXT = "Ja, Hendrik Flügge darf mich zu dieser Berechnung einmal anrufen. (Bei Fragen vor, während oder nach der Anwendung. Nur mit Häkchen oder über „Rückruf anfordern“ geht Ihre Nummer mit der Berechnung an Hendrik – kein Werbeanruf, keine Weitergabe.)";
  var RR_TEXT_KNOPF = "Knopf „Rückruf anfordern →“ nach Eingabe einer Festnetznummer (Hinweis darunter: „Hendrik ruft Sie dort an“).";
  /* v588: eigener Nachweis für das Speichern-Fenster – dort sieht der Kunde eine andere Oberfläche. */
  var RR_TEXT_POPUP = "Speichern-Fenster, Karte „Lieber kurz nachfragen?“: Knopf „Rückruf anfordern“ → Feld „Ihre Telefonnummer – Hendrik ruft Sie an“ → Knopf „Rückruf anfordern“ (Hinweis darunter: „Ihre Nummer geht mit der Berechnung nur an Hendrik – kein Werbeanruf.“).";
  var RR_FRIST_MS = 20000;
  function sendeRueckruf(nr, mail, a, pos, fertig, weg) {
    var gemeldet = false;
    function melde(status) {
      if (gemeldet) {
        /* v551: kam das OK erst nach der Frist, jetzt auch das Lead-Ziel nachsenden (einmal). */
        if (status === "ok") {
          track("ergebnis_rueckruf_ok", {}); fertig("ok");
          try { if (typeof w.logr3Track === "function") w.logr3Track("rueckruf_submit", { source: "speichern_" + pos }); } catch (eS) {}
        }
        return;
      }
      gemeldet = true; fertig(status);
      if (status === "ok") {
        track("ergebnis_rueckruf_ok", {});
        /* Lead-Ziel wie beim Rückrufformular: bewusst OHNE step, damit es als Ziel zählt. */
        try { if (typeof w.logr3Track === "function") w.logr3Track("rueckruf_submit", { source: "speichern_" + pos }); } catch (e) {}
      } else {
        track("ergebnis_rueckruf_fehler", {});
      }
    }
    try {
      var jetzt = new Date();
      var f = d.createElement("form");
      f.method = "post";
      f.action = "/contact";
      f.acceptCharset = "UTF-8";
      f.style.display = "none";
      var body = [
        "RÜCKRUF AN: " + nr.anzeige + "   (international +" + nr.e164 + ")",
        "",
        buildText(a, "rueckruf"),
        "",
        "— Nachweis der Anforderung —",
        (weg === "popup" ? "Angefordert per " + RR_TEXT_POPUP : weg === "knopf" ? "Angefordert per " + RR_TEXT_KNOPF : "Häkchen gesetzt, Wortlaut: „" + RR_TEXT + "“"),
        "Fassung: " + (weg === "popup" ? "2026-10-04 v588" : RR_VERSION),
        "Herkunft: Ergebnisseite " + (w.location && w.location.pathname || "") + (weg === "popup" ? " (Speichern-Fenster)" : " (Speicherfeld, " + pos + ")"),
        "Zeitpunkt: " + jetzt.toISOString()
      ].join("\n");
      var felder = {
        "form_type": "contact",
        "utf8": "✓",
        "return_to": "/cart.js",
        "contact[Ihr Vor- und Nachname]": "Rückruf aus der Berechnung",
        "contact[Ihre Telefonnummer]": nr.anzeige,
        /* Shopify erwartet am Kontaktformular eine Adresse; ohne eigene nehmen wir die
           Rückruf-Adresse, wie es das alte Rückrufformular (isofin-rueckruf-form) auch tat. */
        "contact[email]": mail || "rueckruf@isofin.de",
        "contact[Anfrage von]": "Ergebnisseite · " + (weg === "popup" ? "Speichern-Fenster" : "Speicherfeld (" + pos + ")"),
        "contact[body]": body
      };
      for (var k in felder) {
        if (!Object.prototype.hasOwnProperty.call(felder, k)) continue;
        var inp = d.createElement(k === "contact[body]" ? "textarea" : "input");
        if (inp.tagName === "INPUT") inp.type = "hidden";
        inp.name = k; inp.value = felder[k];
        f.appendChild(inp);
      }
      d.body.appendChild(f);

      /* Absenden per Hintergrundabruf statt Seitenwechsel: Shopify liefert jede Shop-Seite mit
         „X-Frame-Options: DENY" aus, ein versteckter Rahmen könnte das Ergebnis nie lesen.
         Die Antwortadresse verrät es dagegen eindeutig: /cart.js = angenommen, /challenge =
         Bot-Schutz hat abgelehnt, /contact = Shopify hat das Formular zurückgewiesen. */
      function abschicken() {
        var daten;
        try { daten = new URLSearchParams(new FormData(f)).toString(); } catch (eF) { melde("fehler"); return; }
        w.fetch("/contact", {
          /* ohne keepalive: das verträgt sich nicht mit Shopifys Weiterleitung auf return_to
             (Abruf hing im Test), und die Seite bleibt ohnehin offen. */
          method: "POST", credentials: "same-origin", redirect: "follow",
          headers: { "Content-Type": "application/x-www-form-urlencoded" }, body: daten
        }).then(function (r) {
          var ziel = String(r && r.url || "");
          melde(r && r.ok && ziel.indexOf("/cart") !== -1 ? "ok" : "fehler");
        }, function () { melde("fehler"); });
        try { f.remove(); } catch (eR) {}
      }
      /* Shopifys Bot-Schutz (hCaptcha) fängt das submit-Ereignis ab, holt unsichtbar die
         Freigabe (im echten Browser ~1–2 s) und ruft dann f.submit() auf — diese Methode
         übernehmen wir. Ist kein Schutz aktiv, bleibt das Ereignis unberührt und wir senden
         selbst. Geprüft 24.09.2026 im echten Browser: Schutz ruft f.submit() mit Freigabe. */
      f.submit = abschicken;
      var frist = function () {
        if (gemeldet) return;
        /* Auf dem Handy pausiert die Seite, solange WhatsApp vorne ist — dann weiter warten. */
        if (d.hidden) { setTimeout(frist, RR_FRIST_MS); return; }
        melde("fehler");
      };
      setTimeout(frist, RR_FRIST_MS);

      try { f.querySelector("input[type=hidden]").dispatchEvent(new Event("focusin", { bubbles: true })); } catch (e2) {}
      var ev;
      try { ev = new Event("submit", { bubbles: true, cancelable: true }); } catch (e3) { ev = null; }
      /* Kurz warten, damit der Schutz nach dem focusin sein Skript laden kann. */
      setTimeout(function () {
        if (!ev || f.dispatchEvent(ev)) abschicken();
      }, 300);
    } catch (eX) {
      melde("fehler");
    }
  }

  /* ══ v27.22.0: Versand ueber Klaviyo (Client-API, oeffentlicher Schluessel) ══
     Liefert ein Promise<boolean> oder null, wenn kein Schluessel konfiguriert ist.
     Klaviyo bekommt das Ereignis "Bohrplan angefordert" mit allen Werten der
     Berechnung; der Flow dort verschickt die Mail (als transaktional markiert,
     darum auch an Kunden ohne Newsletter-Zustimmung). Das freiwillige Kaestchen
     traegt die Adresse zusaetzlich mit Marketing-Einwilligung in die Liste ein
     (Double-Opt-in regelt Klaviyo nach Listeneinstellung). */
  /* v520 (Bjoern 07.09.): Wortlaut des Kaestchens = Umfang der Einwilligung. Er wird beim
     Anmelden als Profil-Eigenschaft nach Klaviyo mitgeschickt (Nachweispflicht liegt bei uns;
     Klaviyo protokolliert nur, DASS zugestimmt wurde). Aenderung am Text = neue CONSENT_VERSION. */
  /* v527 (Bjoern): kuerzer, das Speichern-Feld brauchte zu viel Platz.
     Alle Pflichtbestandteile bleiben: was man bekommt, wer schickt, dass
     danach Werbung folgt, und der Widerrufshinweis (Paragraf 7 UWG).
     Nur die Fuellwoerter sind raus: 135 -> 99 und 176 -> 120 Zeichen. */
  var CONSENT_LEAD = "Ja, ich m\u00f6chte den Isofin\u00ae Trocknungs-Guide: schneller trocknen mit Ventilator und richtigem L\u00fcften.";
  var CONSENT_SMALL = "2 Mails von Hendrik Fl\u00fcgge (Isofin\u00ae-Support), danach gelegentlich Tipps und Angebote per E-Mail. Jederzeit abbestellbar.";
  var CONSENT_VERSION = "2026-09-07 v520";

  /* Berechnungswerte am Profil (nicht nur am Ereignis): damit koennen die Guide-Mails
     spaeter "Ihre Berechnung: 12 Flaschen ... zur Kasse" zeigen ({{ person|lookup:'…' }}). */
  function profilEigenschaften(props) {
    var pe = {
      berechnung_sperre: props.sperre, berechnung_mauerwerk: props.mauerwerk, berechnung_masse: props.masse,
      berechnung_flaschen: props.flaschen, berechnung_preis: props.preis, berechnung_link: props.link_berechnung,
      kasse_link: props.link_kasse, berechnung_datum: new Date().toISOString().slice(0, 10)
    };
    if (props.aktion_bis) pe.aktion_bis = props.aktion_bis;
    return pe;
  }

  function sendeBohrplanMail(addr, a, tipps, rueckruf) {
    var cfg = w.__ISO_SHARE_CFG__ || {};
    var key = String(cfg.klaviyoKey || "").trim();
    if (!key || typeof w.fetch !== "function") return null;
    var side = a.moistureType === "side";
    var mauer = a.masonryLabel || a.masonryType || "";
    if (mauer) mauer = mauer.charAt(0).toUpperCase() + mauer.slice(1);
    var masse = side
      ? ((a.surfaceLengthM != null ? a.surfaceLengthM : "?") + " m \u00d7 " + (a.surfaceHeightM != null ? a.surfaceHeightM : "?") + " m")
      : ((a.wallLengthM != null ? a.wallLengthM : "?") + " m" + (a.cornerCount ? " \u00b7 " + a.cornerCount + " Ecken" : ""));
    /* Bohrplan-Details 1:1 wie auf der Ergebnisseite (Bjoern 07.09.: "so detailliert wie
       moeglich"). Bohrerlaenge nach derselben Regel wie sec-01 getBohrerLaengeCm. */
    var tiefe = parseInt(a.drillDepthCm, 10) || 0;
    /* v641: gleiche Tabelle wie sec-01 – Gesamtlänge mindestens Länge am Bohrer + 6 cm; 0 = Sonderlänge */
    var bohrerCm = tiefe <= 14 ? 20 : tiefe <= 19 ? 25 : tiefe <= 24 ? 30 : tiefe <= 34 ? 40 : tiefe <= 44 ? 50 : tiefe <= 54 ? 60 : tiefe <= 74 ? 80 : tiefe <= 94 ? 100 : 0;
    var beton = !!a.isConcrete;
    var abstand = Number(a.drillSpacingCm) || (beton ? 12.5 : 25);
    var mlLoch = Number(a.mlPerHole) || (beton ? 250 : 500);
    var props = {
      sperre: a.barrierLabel || (side ? "Fl\u00e4chensperre" : "Horizontalsperre"),
      mauerwerk: mauer + (a.wallThicknessCm ? ", " + a.wallThicknessCm + " cm" : ""),
      masse: masse,
      flaschen: Number(a.calculatedBottles) || 0,
      bohrloecher: Number(a.holeCount) || 0,
      bohrabstand: String(abstand).replace(".", ",") + " cm" + (beton ? " (Beton: halber Abstand)" : ""),
      bohrwinkel: (Number(a.drillAngleDeg) || 45) + "\u00b0 nach unten",
      bohrtiefe: tiefe ? tiefe + " cm am Bohrer" + (a.wallThicknessCm ? " \u2013 reicht rund " + Math.round(a.wallThicknessCm * 2 / 3) + " cm in die Wand (etwa zwei Drittel)" : "") : "",
      bohrer: "10\u201312 mm Stein- oder SDS-Bohrer, " + (bohrerCm ? "mindestens " + bohrerCm + " cm lang" : "Sonderl\u00e4nge (bitte Hendrik fragen)"),
      maschine: String(a.drillMachineRecommendation || "Bohrhammer SDS+ ab 800 W empfohlen"),
      menge_je_loch: mlLoch + " ml" + (mlLoch === 500 ? " (eine Flasche)" : ""),
      arbeitszeit: String(a.workTimeRangeText || a.workTimeTextShort || ""),
      preis: fmtEuro(a.totalPriceIsofin),
      preis_zahl: Math.round((Number(a.totalPriceIsofin) || 0) * 100) / 100,
      link_berechnung: resumeUrl(a, "email") || "",
      link_kasse: checkoutUrl(a, "email"),
      text: buildText(a, "email"),
      tipps_gewuenscht: !!tipps,
      /* v550: nur JA/NEIN, NIE die Nummer. Die Nummer geht ausschließlich über das
         Shopify-Kontaktformular ins Isofin-Postfach — Klaviyo ist ein Werbewerkzeug, und
         für Werbung hat der Kunde seine Nummer nicht gegeben (Zweckbindung). */
      rueckruf_gewuenscht: !!rueckruf,
      /* v588: Geraet beim Speichern (mobil/tablet/desktop) – mit dem Klick-Geraet der
         Mail vergleichbar: speichern Handy-Nutzer und oeffnen am PC? Nur am Ereignis,
         bewusst nicht am Profil (fuer die Frage nicht noetig). Rueckruf: leer. */
      geraet: GERAET || "",
      quelle: "ergebnisseite"
    };
    /* Aktion Paket 2 (BAULISTE 4.2 Nr. 22): In der Aktion das feste Ende mitsenden, an Ereignis
       UND Profil — der Profilpreis berechnung_preis bleibt nach dem 30.11. stehen. Der Flow
       erkennt damit, ob der Preis noch gilt (berechnung_datum gegen aktion_bis). Außerhalb der
       Aktion bleibt die Nutzlast exakt wie vorher (kein leeres Feld).
       Nachbesserung 04.10. (Prüfung Technik K2): nicht in der Vorschau (messenErlaubt() false),
       sonst trüge ein internes Testprofil das Aktionsende. */
    if (aktionLaeuft() && w.ISO_AKTION.aktionBis && (typeof w.ISO_AKTION.messenErlaubt !== "function" || w.ISO_AKTION.messenErlaubt())) props.aktion_bis = w.ISO_AKTION.aktionBis;
    var headers = { "Content-Type": "application/json", "revision": "2024-10-15" };
    var evBody = { data: { type: "event", attributes: {
      properties: props,
      metric: { data: { type: "metric", attributes: { name: "Bohrplan angefordert" } } },
      profile: { data: { type: "profile", attributes: { email: addr, properties: profilEigenschaften(props) } } }
    } } };
    var p = withTimeout(w.fetch("https://a.klaviyo.com/client/events/?company_id=" + encodeURIComponent(key), {
      method: "POST", headers: headers, body: JSON.stringify(evBody), keepalive: true
    }), 6000).then(function (r) { return !!(r && (r.ok || r.status === 202)); }, function () { return false; });
    if (tipps && cfg.klaviyoListId) {
      try {
        var subBody = { data: { type: "subscription", attributes: {
          custom_source: "Ergebnisseite Trocknungs-Guide",
          profile: { data: { type: "profile", attributes: {
            email: addr,
            properties: (function () {
              var pe = profilEigenschaften(props);
              pe.einwilligung_text = CONSENT_LEAD + " " + CONSENT_SMALL;
              pe.einwilligung_version = CONSENT_VERSION;
              pe.einwilligung_quelle = "Ergebnisseite /pages/kalkulator (Speicher-Schublade)";
              pe.einwilligung_datum = new Date().toISOString();
              return pe;
            })()
            /* v523: KEIN subscriptions-Block. Klaviyo lehnt ihn an /client/subscriptions/ ab
               ("'subscriptions' is not a valid field for the resource 'profile'", HTTP 400).
               Die Einwilligung ergibt sich aus dem Endpunkt plus dem Double-Opt-in der Liste. */
          } } }
        }, relationships: { list: { data: { type: "list", id: String(cfg.klaviyoListId) } } } } };
        w.fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(key), {
          method: "POST", headers: headers, body: JSON.stringify(subBody), keepalive: true
        }).then(function (r) {
          /* v523: Ergebnis auswerten. Vorher verschwand jeder Fehler in einem leeren catch,
             deshalb blieb die Ablehnung monatelang unbemerkt. */
          var ok = !!(r && (r.ok || r.status === 202));
          track("ergebnis_guide_optin_" + (ok ? "ok" : "fehler"), {});
          if (!ok && r && typeof r.text === "function") {
            r.text().then(function (t) {
              try { (w.console && w.console.warn) && w.console.warn("[iso] Guide-Anmeldung abgelehnt", r.status, t); } catch (e3) {}
            }, function () {});
          }
        }, function () { track("ergebnis_guide_optin_fehler", {}); });
      } catch (eS) { track("ergebnis_guide_optin_fehler", {}); }
    }
    return p;
  }

  var sheetEl = null, ovEl = null, sheetAusloeser = null;
  var _fbLeadFired = false; /* v441: FB-Lead nur einmal pro Seitenaufruf feuern */
  function buildSheet() {
    if (sheetEl) return;
    ovEl = d.createElement("div");
    ovEl.className = "ies-ov";
    sheetEl = d.createElement("div");
    sheetEl.className = "ies-sheet ies-sheet--split";
    sheetEl.setAttribute("role", "dialog");
    sheetEl.setAttribute("aria-label", "Speichern oder kurz nachfragen");
    sheetEl.setAttribute("aria-modal", "true");
    sheetEl.innerHTML = "" +
      /* v588 (Adrian 04.10.: „Hendrik und Speichern fifty-fifty, klar getrennt“): zwei gleich große
         Karten — links Speichern (dieselbe E-Mail-Karte wie auf der Ergebnisseite), rechts Hendrik.
         Am Rechner nebeneinander, am Handy untereinander mit „oder“ dazwischen. */
      '<div class="ies-head"><p class="ies-title">Speichern oder kurz nachfragen</p>' +
      '<button type="button" class="ies-x" aria-label="Schließen">✕</button></div>' +
      '<button type="button" class="ies-k-sprung"></button>' +
      '<div class="ies-split">' +
        '<section class="ies-k ies-k-save" aria-label="Für später speichern">' +
          '<p class="ies-k-ttl"><span aria-hidden="true">\ud83d\udcbe</span> Für später speichern</p>' +
          '<p class="ies-k-txt">Berechnung und Bohrplan per E-Mail – auf jedem Gerät wieder öffnen.</p>' +
          '<div class="ies-sheet-karte"></div>' +
          '<button type="button" class="ies-opt ies-k-copy" data-ies="copy"><span class="ies-ic">📋</span><span id="ies-copy-label">Link kopieren</span></button>' +
        '</section>' +
        '<p class="ies-k-oder" aria-hidden="true"><span>oder</span></p>' +
        '<section class="ies-k ies-k-hendrik" aria-label="Hendrik Flügge fragen">' +
          '<div class="ies-k-kopf"><img class="ies-k-foto" src="' + HENDRIK_FOTO + '" alt="Hendrik Flügge" width="64" height="64" loading="lazy" decoding="async">' +
          '<div><p class="ies-k-ttl">Lieber kurz nachfragen?</p><p class="ies-k-name">Hendrik Flügge · Mauerwerks-Abdichtungsexperte</p></div></div>' +
          '<p class="ies-k-zeit"></p>' +
          '<p class="ies-k-txt">Unsicher, ob alles passt? Hendrik schaut sich Ihre Berechnung kostenlos mit an.</p>' +
          '<div class="ies-k-wege">' +
          '<a class="ies-k-btn ies-k-tel" href="tel:+491708449472">\ud83d\udcde 0170 844 94 72 anrufen</a>' +
          '<a class="ies-k-btn ies-k-wa" href="https://wa.me/491708449472?text=' + encodeURIComponent("Hallo Herr Flügge, ich habe meine Berechnung auf isofin.de gemacht und hätte eine kurze Frage.") + '" target="_blank" rel="noopener"><svg class="ies-k-walogo" viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path fill="#25D366" d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg><span>WhatsApp schreiben</span></a>' +
          '<div class="ies-k-rrblock"><button type="button" class="ies-k-btn ies-k-rr">Rückruf anfordern</button>' +
          '<div class="ies-k-rrfeld"><label class="ies-k-lab" for="ies-k-rrtel">Ihre Telefonnummer – Hendrik ruft Sie an</label>' +
          '<div class="ies-k-rrzeile"><input type="tel" id="ies-k-rrtel" inputmode="tel" autocomplete="tel" placeholder="0170 1234567 oder 030 1234567">' +
          '<button type="button" class="ies-k-rrgo">Rückruf anfordern</button></div>' +
          '<p class="ies-k-err">Bitte prüfen Sie die Nummer – mit Vorwahl, z.\u00a0B. 0170 1234567.</p>' +
          '<p class="ies-k-hinweis">Ihre Nummer geht mit der Berechnung nur an Hendrik – kein Werbeanruf. <a href="/policies/privacy-policy" target="_blank" rel="noopener">Datenschutz</a></p></div></div>' +
          '</div>' +
          '<div class="ies-mail-ok ies-k-ok" role="status"></div>' +
        '</section>' +
      '</div>';
    d.body.appendChild(ovEl);
    d.body.appendChild(sheetEl);

    function close() {
      var warOffen = sheetEl.classList.contains("is-on");
      ovEl.classList.remove("is-on");
      sheetEl.classList.remove("is-on");
      /* v588: Fokus zurück an den auslösenden Knopf */
      if (warOffen && sheetAusloeser && sheetAusloeser.focus) { try { sheetAusloeser.focus({ preventScroll: true }); } catch (eF) {} }
    }
    ovEl.addEventListener("click", close);
    sheetEl.querySelector(".ies-x").addEventListener("click", close);
    d.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });

    /* v588: dieselbe Karte wie auf der Ergebnisseite – gleiche Verdrahtung, gleiche Ereignisse
       (ergebnis_save_email…, Logr3 zusätzlich ergebnis_save_email_inline_popup). */
    try { sheetEl.querySelector(".ies-sheet-karte").appendChild(makeButtonRow("ies-sheet-row", "popup")); } catch (eK) {}
    /* v588: Sprungzeile (nur Handy sichtbar) – Hendrik liegt dort unter der Speichern-Karte. */
    try {
      sheetEl.querySelector(".ies-k-sprung").addEventListener("click", function () {
        var hk = sheetEl.querySelector(".ies-k-hendrik");
        if (hk) { try { hk.scrollIntoView({ behavior: "smooth", block: "start" }); } catch (eS) { hk.scrollIntoView(); } }
        track("ergebnis_speichern_hendrik_sprung_popup", {});
      });
    } catch (eJ) {}

    /* v588: Hendrik-Karte – Anruf, WhatsApp, Rückruf (gleiche Ereignisse wie im Aufklapper der Ergebnisseite). */
    (function () {
      var hk = sheetEl.querySelector(".ies-k-hendrik"); if (!hk) return;
      var tel = hk.querySelector(".ies-k-tel"), wa = hk.querySelector(".ies-k-wa"), rrBtn = hk.querySelector(".ies-k-rr"),
          feld = hk.querySelector(".ies-k-rrfeld"), inp = hk.querySelector("#ies-k-rrtel"), go = hk.querySelector(".ies-k-rrgo"),
          err = hk.querySelector(".ies-k-err"), ok = hk.querySelector(".ies-k-ok");
      var stand = {};
      if (tel) tel.addEventListener("click", function () { track("ergebnis_speichern_hendrik_tel", {}); track("ergebnis_speichern_hendrik_tel_popup", {}); });
      if (wa) wa.addEventListener("click", function () { track("ergebnis_speichern_hendrik_wa", {}); track("ergebnis_speichern_hendrik_wa_popup", {}); });
      if (rrBtn) rrBtn.addEventListener("click", function () {
        feld.classList.add("is-on"); rrBtn.style.display = "none";
        track("ergebnis_rueckruf_auf", {}); track("ergebnis_rueckruf_auf_popup", {});
        setTimeout(function () { try { inp.focus(); } catch (e) {} }, 60);
      });
      function zeige(html, fehler) { ok.innerHTML = html; ok.classList.toggle("is-on", !!html); ok.classList.toggle("is-fehler", !!fehler); }
      function senden() {
        var a = getAnalysis(); if (!a) return;
        var nr = leseNummer(inp.value);
        if (!nr.e164) { err.classList.add("is-on"); try { inp.focus(); } catch (e) {} return; }
        err.classList.remove("is-on");
        if (stand[nr.e164] === "laeuft" || stand[nr.e164] === "ok") return;
        stand[nr.e164] = "laeuft"; go.disabled = true;
        zeige("Rückrufbitte wird übermittelt …");
        sendeRueckruf(nr, "", a, "popup", function (status) {
          go.disabled = false;
          stand[nr.e164] = status === "ok" ? "ok" : "";
          if (status === "ok") zeige("\u2713 Hendrik Flügge ruft Sie unter <b>" + nr.anzeige.replace(/[<>&]/g, "") + "</b> an und hat Ihre Berechnung dabei.");
          else zeige('Das hat nicht geklappt. Bitte rufen Sie direkt an: <a href="tel:+491708449472">0170 844 94 72</a> · gebührenfrei <a href="tel:08002266245">0800 22 66 245</a>', true);
        }, "popup");
        try { w.sessionStorage.setItem(EXIT_KEY, "1"); } catch (eE) {}
      }
      if (go) go.addEventListener("click", senden);
      if (inp) inp.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); senden(); } });
    })();

    /* Link kopieren */
    sheetEl.querySelector('[data-ies="copy"]').addEventListener("click", function () {
      var a = getAnalysis(); if (!a) return;
      /* v419 (Björn): nicht nur den Link, sondern die KOMPLETTE Nachricht
         kopieren (gleicher Text wie WhatsApp/E-Mail) — zum Einfügen wo
         immer der Kunde mag. */
      var url = buildText(a, "copy"); if (!url) return;
      var label = d.getElementById("ies-copy-label");
      function done(ok) {
        label.textContent = ok ? "✓ Kopiert!" : "Kopieren nicht möglich";
        setTimeout(function () { label.textContent = "Link kopieren"; close(); }, 1400);
      }
      track("ergebnis_save_copy", { bottles: a.calculatedBottles });
      track("ergebnis_save_size_" + groessenklasse(a.calculatedBottles), {});
      if (GERAET) track("ergebnis_save_geraet_" + GERAET, {});
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () { done(true); }, function () { fallbackCopy(url, done); });
      } else { fallbackCopy(url, done); }
    });
  }
  function fallbackCopy(text, cb) {
    try {
      var ta = d.createElement("textarea");
      ta.value = text;
      ta.style.cssText = "position:fixed;left:-9999px;top:0";
      d.body.appendChild(ta);
      ta.select();
      var ok = d.execCommand("copy");
      d.body.removeChild(ta);
      cb(!!ok);
    } catch (e) { cb(false); }
  }
  function openSheet(pos) {
    var a = getAnalysis();
    if (!a) return;
    buildSheet();
    /* für Test/Debug: aktuelle Links am Sheet hinterlegen */
    try { sheetEl.setAttribute("data-resume", resumeUrl(a) || ""); sheetEl.setAttribute("data-checkout", checkoutUrl(a)); } catch (e) {}
    /* A3 (Dev-Auftrag 14.08.): pos als Parameter ist in Logr3 nicht auswertbar —
       deshalb zwei getrennte Event-Namen. Popup gegen Seiten-Knopf wird damit
       endlich vergleichbar. */
    track("ergebnis_save_open_" + (pos === "exit" ? "exit" : "btn"), { bottles: a.calculatedBottles });
    /* v421: Wer die Schublade einmal offen hatte, kennt das Speichern —
       das Exit-Popup (gleiche Frage) darf danach nie mehr erscheinen. */
    try { w.sessionStorage.setItem(EXIT_KEY, "1"); } catch (eE) {}
    /* v588: Hendrik-Wege nach Servicezeit ordnen – erreichbar: Anrufen zuerst; sonst Rückruf zuerst. */
    try {
      var hk = sheetEl.querySelector(".ies-k-hendrik"), offen = istErreichbar();
      if (hk) {
        hk.classList.toggle("is-zu", !offen);
        /* Reihenfolge im DOM (nicht nur optisch), damit Tastatur und Vorleseprogramm sie auch so lesen */
        var wege = hk.querySelector(".ies-k-wege"), rb = hk.querySelector(".ies-k-rrblock"),
            tb = hk.querySelector(".ies-k-tel"), wb = hk.querySelector(".ies-k-wa");
        if (wege && rb && tb && wb) {
          if (offen) { wege.appendChild(tb); wege.appendChild(wb); wege.appendChild(rb); }
          else { wege.appendChild(rb); wege.appendChild(wb); wege.appendChild(tb); }
        }
        var zt = hk.querySelector(".ies-k-zeit");
        if (zt) zt.innerHTML = offen
          ? '<span class="ies-k-punkt"></span>Jetzt erreichbar · ' + OEFFNUNG_HTML
          : "Gerade nicht erreichbar – fordern Sie einen Rückruf an, Hendrik meldet sich in der nächsten Servicezeit (" + OEFFNUNG_HTML + ").";
        var sp = sheetEl.querySelector(".ies-k-sprung");
        if (sp) sp.innerHTML = offen ? '<span class="ies-k-punkt"></span>Hendrik ist jetzt erreichbar – Anrufen oder WhatsApp <span aria-hidden="true">↓</span>'
          : 'Lieber einen Rückruf von Hendrik? <span aria-hidden="true">↓</span>';
      }
    } catch (eH) {}
    try { sheetAusloeser = d.activeElement && d.activeElement !== d.body ? d.activeElement : null; } catch (eA) {}
    ovEl.classList.add("is-on");
    sheetEl.classList.add("is-on");
    try { var xb = sheetEl.querySelector(".ies-x"); if (xb) xb.focus({ preventScroll: true }); } catch (eX) {}
  }

  /* v521 (Bjoern 07.09.): Die Speichern-Reihe IST jetzt das E-Mail-Formular. Vorher: Knopf ->
     Schublade -> "Per E-Mail" -> Feld -> Senden (drei Schritte bis zur Adresse). Jetzt: Adresse
     tippen, Senden. Die Schublade bleibt fuer WhatsApp/Kopieren ueber "Andere Wege" erreichbar.
     Zwei Reihen (oben/unten) -> Klassen statt IDs, jede Reihe verdrahtet sich selbst. */
  function makeButtonRow(id, pos) {
    var row = d.createElement("div");
    row.className = "ies-row ies-inline";
    row.id = id;
    var cfgK = w.__ISO_SHARE_CFG__ || {};
    var consent = !!(String(cfgK.klaviyoKey || "").trim() && cfgK.klaviyoListId);
    /* v525 (Björn 09.09.): „Technisch muss das eins zu eins genauso funktionieren" —
       geändert sind ausschließlich Auszeichnung und Anordnung. Kopf mit eigener
       Symbolspalte, sichtbares Label über dem Feld, Feld und Knopf untereinander
       (nebeneinander blieben auf 390 px rund 210 px für eine Adresse übrig).
       Alle Klassennamen, IDs, Ereignisnamen und die Verdrahtung bleiben. */
    var feldId = id + "-addr";
    row.innerHTML =
      /* v577 (Adrian 29.09.: „nicht so fett … nur E-Mail, dann mit Klaviyo“): schlanke Karte – Titel, EIN
         E-Mail-Feld mit Knopf daneben (Handy: darunter), keine Erklärzeile, Beschriftung nur für Vorleseprogramme.
         Handynummer/WhatsApp entfällt hier; Versand wie bisher über Klaviyo (sendeBohrplanMail). */
      '<div class="ies-inl-head"><span class="ies-inl-ic" aria-hidden="true">\ud83d\udcbe</span>' +
      '<p class="ies-inl-ttl">Berechnung und Bohrplan per E-Mail speichern</p></div>' +
      '<label class="ies-sr" for="' + feldId + '">Ihre E-Mail-Adresse</label>' +
      '<div class="ies-inl-row"><input type="email" id="' + feldId + '" class="ies-inl-addr" inputmode="email" autocomplete="email" autocapitalize="off" autocorrect="off" spellcheck="false" placeholder="Ihre E-Mail-Adresse" aria-describedby="' + feldId + '-erk">' +
      '<button type="button" class="ies-inl-go">Zuschicken</button></div>' +
      '<p class="ies-inl-erk" id="' + feldId + '-erk" aria-live="polite"></p>' +
      '<p class="ies-inl-err">Bitte pr\u00fcfen Sie Ihre E-Mail-Adresse (z.\u00a0B. name@beispiel.de).</p>' +
      (consent ? '<label class="ies-consent ies-inl-guide"><input type="checkbox" class="ies-inl-consent-box"><span><span class="ies-consent-lead">' + CONSENT_LEAD + '</span><span class="ies-consent-small">' + CONSENT_SMALL + '</span></span></label>' : '') +
      /* v550: Rückruf-Angebot. Häkchen startet LEER (vorangekreuzt wäre keine Einwilligung).
         v572 (Adrian 29.09.): „nur mit Trocknung, ohne extra Hendrik – wenn, dann zum Ausklappen“.
         Der Kasten steht jetzt zugeklappt in einer Zeile; Inhalt, Klassen und Verdrahtung unverändert. */
      '<details class="ies-rr-auf"><summary class="ies-rr-sum"><img class="ies-rr-sumfoto" src="' + HENDRIK_FOTO + '" alt="Hendrik Flügge" width="40" height="40" loading="lazy" decoding="async"><span class="ies-rr-sumtxt">Unsicher, ob alles passt?<span>Hendrik Flügge hilft Ihnen gern</span></span></summary>' +
      '<div class="ies-rr">' +
        '<div class="ies-rr-kopf"><img class="ies-rr-foto" src="' + HENDRIK_FOTO + '" alt="Hendrik Flügge" width="44" height="44" loading="lazy" decoding="async">' +
        '<p class="ies-rr-ttl">Hendrik Flügge ruft Sie kostenlos an<span>' + OEFFNUNG_TEXT.replace(/–/g, "–\u2060") + '.</span></p></div>' +
        '<label class="ies-rr-lab"><input type="checkbox" class="ies-rr-box">' +
        '<span><span class="ies-rr-lead">Ja, Hendrik Flügge darf mich zu dieser Berechnung einmal anrufen.</span>' +
        '<span class="ies-rr-small">Bei Fragen vor, während oder nach der Anwendung. Nur mit Häkchen oder über „Rückruf anfordern“ geht Ihre Nummer mit der Berechnung an Hendrik – kein Werbeanruf, keine Weitergabe. <a href="/policies/privacy-policy" target="_blank" rel="noopener">Datenschutz</a></span></span></label>' +
        '<div class="ies-rr-telwrap"><label class="ies-inl-lab" for="' + feldId + '-rrtel">Ihre Telefonnummer f\u00fcr den R\u00fcckruf</label>' +
        '<input type="tel" id="' + feldId + '-rrtel" class="ies-rr-tel" inputmode="tel" autocomplete="tel" placeholder="0170 1234567 oder 030 1234567">' +
        '<p class="ies-rr-err">Bitte pr\u00fcfen Sie die Nummer \u2013 mit Vorwahl, z.\u00a0B. 0170 1234567.</p></div>' +
        '<p class="ies-rr-direkt">Oder direkt: <a class="ies-rr-dtel" href="tel:+491708449472">0170 844 94 72</a> · <a class="ies-rr-dwa" href="https://wa.me/491708449472?text=' + encodeURIComponent("Hallo Herr Flügge, ich habe meine Berechnung auf isofin.de gemacht und hätte eine kurze Frage.") + '" target="_blank" rel="noopener">WhatsApp</a></p>' +
      '</div></details>' +
      '<div class="ies-mail-ok ies-inl-ok" role="status"></div>' +
      '';
    wireInline(row, pos);
    return row;
  }

  function wireInline(row, pos) {
    var addr = row.querySelector(".ies-inl-addr"), go = row.querySelector(".ies-inl-go"),
        err = row.querySelector(".ies-inl-err"), ok = row.querySelector(".ies-inl-ok"),
        box = row.querySelector(".ies-inl-consent-box"), alt = row.querySelector(".ies-inl-altbtn"),
        guide = row.querySelector(".ies-inl-guide"), erk = row.querySelector(".ies-inl-erk"),
        rrBox = row.querySelector(".ies-rr-box"), rrWrap = row.querySelector(".ies-rr-telwrap"),
        rrTel = row.querySelector(".ies-rr-tel"), rrErr = row.querySelector(".ies-rr-err");
    var GO_TEXT = go ? go.textContent : "";
    /* v551: recall() liefert immer "" (kein Vorausfüllen mehr, siehe remember/recall oben). */
    try { if (addr && !addr.value) addr.value = recall("__IES_MAIL_ADDR__") || recall("__IES_WA_NUM__"); } catch (e0) {}
    if (alt) alt.addEventListener("click", function () { track("ergebnis_save_alt_open_" + pos, {}); openSheet(pos); });
    if (addr) addr.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); go.click(); } });
    if (rrTel) rrTel.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); go.click(); } });
    /* v573: direkte Wege zu Hendrik im Aufklapper (eigene Namen – die _size_-Reihe der Hendrik-Karte bleibt unberührt). */
    var dTel = row.querySelector(".ies-rr-dtel"), dWa = row.querySelector(".ies-rr-dwa");
    if (dTel) dTel.addEventListener("click", function () { track("ergebnis_speichern_hendrik_tel", {}); });
    if (dWa) dWa.addEventListener("click", function () { track("ergebnis_speichern_hendrik_wa", {}); });
    /* v572: erstes Aufklappen des Rückruf-Kastens je Karte messen. */
    var rrAuf = row.querySelector(".ies-rr-auf");
    if (rrAuf) rrAuf.addEventListener("toggle", function () {
      if (rrAuf.open && !rrAuf.getAttribute("data-gemessen")) { rrAuf.setAttribute("data-gemessen", "1"); track("ergebnis_rueckruf_auf", {}); }
    });
    if (!go) return;

    /* v550: Die Karte reagiert beim Tippen. Sie sagt in Klartext, was sie erkannt hat, und
       passt Knopf und Zusatzfelder an — damit niemand raten muss, was nach dem Klick passiert. */
    function aktualisiere() {
      var k = erkenneKontakt(addr.value);
      /* v577: Hauptfeld nimmt nur noch E-Mail – eine Nummer wird nicht mehr als WhatsApp/Festnetz behandelt. */
      var nurMail = true;
      var istNummer = !nurMail && k.art === "nummer";
      var festnetz = istNummer && !k.nummer.whatsapp;
      /* Der Trocknungs-Guide ist ein E-Mail-Angebot — bei einer Nummer ausblenden und abwählen. */
      if (guide) {
        var zeig = true; /* v577: nur E-Mail – der Guide bleibt immer sichtbar */
        guide.style.display = zeig ? "" : "none";
        if (!zeig && box) box.checked = false;
      }
      var t = "", cls = "";
      if (k.art === "nummer" || k.art === "nummer_unfertig") { t = "Bitte eine E-Mail-Adresse eingeben. Für einen Rückruf nutzen Sie die Zeile mit Hendrik unten."; cls = "hinweis"; }
      else if (k.art === "mail") { t = ""; cls = ""; }
      else if (istNummer && !festnetz) { t = "✓ Handynummer erkannt – die Berechnung öffnet sich in WhatsApp, zum Senden an Sie selbst."; cls = "ok"; }
      else if (festnetz) { t = "Festnetznummer erkannt – Hendrik ruft Sie dort an: einfach „Rückruf anfordern“ wählen. Zum Speichern bitte eine E-Mail-Adresse oder Handynummer eingeben."; cls = "hinweis"; }
      if (erk) { erk.textContent = t; erk.className = "ies-inl-erk" + (cls ? " is-" + cls : ""); }
      /* Zusatzfeld für die Rückrufnummer nur, wenn angehakt UND oben keine Nummer steht. */
      var brauchtTel = !!(rrBox && rrBox.checked) && !istNummer;
      if (rrWrap) rrWrap.classList.toggle("is-on", brauchtTel);
      if (festnetz) go.textContent = "Rückruf anfordern →";
      else if (istNummer) go.textContent = "Per WhatsApp an mich senden →";
      else go.textContent = GO_TEXT;
      err.classList.remove("is-on");
    }
    addr.addEventListener("input", aktualisiere);
    if (rrBox) rrBox.addEventListener("change", function () {
      if (rrBox.checked) track("ergebnis_rueckruf_haekchen", {});
      aktualisiere();
      if (rrBox.checked && rrWrap && rrWrap.classList.contains("is-on")) setTimeout(function () { try { rrTel.focus(); } catch (e) {} }, 60);
    });
    aktualisiere();

    /* Zwei getrennte Zeilen: „haupt" (E-Mail/WhatsApp) und „rr" (Rückruf) — sie kommen zu
       unterschiedlichen Zeiten zurück und dürfen sich nicht gegenseitig überschreiben. */
    var zeilen = { haupt: "", rr: "" };
    function zeige() {
      ok.innerHTML = [zeilen.haupt, zeilen.rr].filter(Boolean).join("<br>");
      ok.classList.toggle("is-on", !!ok.innerHTML);
    }
    function setze(was, html) { zeilen[was] = html; zeige(); }
    function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
    var RR_FEHLER_HTML = "Die Rückrufbitte konnte nicht automatisch übermittelt werden. Bitte rufen Sie Hendrik direkt an: " +
      '<a href="tel:+491708449472">0170 844 94 72</a> · gebührenfrei <a href="tel:08002266245">0800 22 66 245</a> ' +
      '– oder nutzen Sie das <a href="/pages/rueckruf-anfragen">Rückrufformular</a>.';

    /* v551: Sperre gegen Doppeltipp/Wiederholung — je Nummer höchstens eine laufende oder
       angekommene Bitte; nur nach einem Fehler darf erneut gesendet werden (Schlussprüfung 25.09.). */
    var rrStand = {};
    function starteRueckruf(nr, mail, a, weg) {
      var schluessel = nr.e164;
      if (rrStand[schluessel] === "laeuft") return;
      if (rrStand[schluessel] === "ok") {
        setze("rr", "✓ Ihre Rückrufbitte für <b>" + esc(nr.anzeige) + "</b> ist schon bei Hendrik Flügge angekommen. Er meldet sich in unseren Servicezeiten (" + esc(OEFFNUNG_TEXT).replace(/–/g, "–\u2060") + ").");
        return;
      }
      rrStand[schluessel] = "laeuft";
      setze("rr", "Rückrufbitte wird übermittelt …");
      sendeRueckruf(nr, mail, a, pos, function (status) {
        rrStand[schluessel] = status === "ok" ? "ok" : "";
        if (status === "ok") {
          ok.classList.remove("is-fehler");
          setze("rr", "✓ Hendrik Flügge ruft Sie unter <b>" + esc(nr.anzeige) + "</b> an und hat Ihre Berechnung dabei. Er meldet sich in unseren Servicezeiten (" + esc(OEFFNUNG_TEXT).replace(/–/g, "–\u2060") + ").");
        } else {
          ok.classList.add("is-fehler");
          setze("rr", RR_FEHLER_HTML);
        }
      }, weg || "haekchen");
    }

    go.addEventListener("click", function () {
      var a = getAnalysis(); if (!a) return;
      var k = erkenneKontakt(addr.value);
      /* v577: nur E-Mail – eine Nummer im Hauptfeld gilt als ungültige Angabe. */
      if (k.art === "nummer" || k.art === "nummer_unfertig") k = { art: "falsch", wert: addr.value };
      var rr = !!(rrBox && rrBox.checked);
      ok.classList.remove("is-fehler"); zeilen.haupt = ""; zeilen.rr = ""; zeige();

      /* Rückrufnummer bestimmen: steht oben eine Nummer, gilt die; sonst das Zusatzfeld. */
      var rrNr = null;
      if (rr) {
        if (k.art === "nummer") rrNr = k.nummer;
        else {
          var kt = leseNummer(rrTel ? rrTel.value : "");
          if (!kt.e164) { if (rrErr) rrErr.classList.add("is-on"); try { rrTel.focus(); } catch (eT) {} return; }
          if (rrErr) rrErr.classList.remove("is-on");
          rrNr = kt;
        }
      }

      /* ── Weg 1: E-Mail — exakt der bisherige Ablauf, gleiche Ereignisse ── */
      if (k.art === "mail") {
        var mail = k.wert;
        err.classList.remove("is-on");
        remember("__IES_MAIL_ADDR__", mail);
        track("ergebnis_save_email", { bottles: a.calculatedBottles });
        track("ergebnis_save_email_inline_" + pos, {});
        track("ergebnis_save_size_" + groessenklasse(a.calculatedBottles), {});
        if (GERAET) track("ergebnis_save_geraet_" + GERAET, {});
        var url = "mailto:" + mail + "?subject=" + encodeURIComponent("Meine Isofin®-Berechnung – Bohrplan & Bestell-Link") +
          "&body=" + encodeURIComponent(buildText(a, "email"));
        if (w.__IES_TEST_MAIL__) { w.__IES_TEST_MAIL__(url); return; }
        var tipps = !!(box && box.checked);
        /* Rückruf zuerst anstoßen — er hängt nicht am Mailversand. */
        if (rrNr) starteRueckruf(rrNr, mail, a);
        var mailtoInline = function () {
          track("ergebnis_save_email_mailto", {});
          try { var ml = d.createElement("a"); ml.href = url; ml.style.display = "none"; d.body.appendChild(ml); ml.click(); ml.remove(); }
          catch (e1) { try { w.location.href = url; } catch (e2) {} }
          setze("haupt", esc("Ihr E-Mail-Programm öffnet sich – bitte dort auf Senden drücken. Kein Programm geöffnet? Dann versuchen Sie es bitte gleich noch einmal."));
        };
        var via = sendeBohrplanMail(mail, a, tipps, !!rrNr);
        if (!via) { mailtoInline(); return; }
        go.disabled = true; go.textContent = "Sende …";
        via.then(function (sent) {
          /* v550: Knopftext zurück auf den ursprünglichen Wortlaut (vorher stand danach „Senden"). */
          go.disabled = false; aktualisiere();
          if (!sent) { mailtoInline(); return; }
          track("ergebnis_save_email_klaviyo", {});
          /* v642 (31.10.2026, Start-Brief NOVA): Meta-Zaehler fuer die per Mail gespeicherte Berechnung.
             Nur hier, wo Klaviyo den Versand bestaetigt hat; der mailto-Ersatzweg zaehlt nicht. */
          try {
            if (typeof w.isofinFB === "function") {
              var fbEur = Math.round((Number(a.totalPriceIsofin) || 0) * 100) / 100;
              var fbDaten = { content_name: "Berechnung per Mail gespeichert", flaschen: Number(a.calculatedBottles) || 0 };
              if (fbEur > 0) { fbDaten.value = fbEur; fbDaten.currency = "EUR"; }
              w.isofinFB("BerechnungGespeichert", fbDaten, true);
            }
          } catch (eFB) {}
          track("ergebnis_save_email_tipps_" + (tipps ? "ja" : "nein"), {});
          setze("haupt", "✓ Gesendet an " + esc(mail) + " – schauen Sie in Ihr Postfach." + (tipps ? " Den Trocknungs-Guide bestätigen Sie über den Link in der zweiten Mail." : ""));
          try { w.sessionStorage.setItem(EXIT_KEY, "1"); } catch (eE) {}
        });
        return;
      }

      /* ── Weg 2: Handynummer — WhatsApp an sich selbst (wie in der Schublade) ── */
      if (k.art === "nummer" && k.nummer.whatsapp) {
        err.classList.remove("is-on");
        remember("__IES_WA_NUM__", addr.value);
        track("ergebnis_save_whatsapp", { bottles: a.calculatedBottles });
        track("ergebnis_save_whatsapp_inline_" + pos, {});
        track("ergebnis_save_size_" + groessenklasse(a.calculatedBottles), {});
        if (GERAET) track("ergebnis_save_geraet_" + GERAET, {});
        /* Rückruf VOR WhatsApp anstoßen: Auf dem Handy übernimmt gleich die WhatsApp-App und
           der Browser kann pausieren — so hat die Rückrufbitte den größten Vorsprung. */
        setze("haupt", "✓ WhatsApp öffnet sich – dort nur noch auf Senden tippen.");
        if (rrNr) starteRueckruf(rrNr, "", a);
        /* w.open muss synchron im Klick bleiben, sonst blockt der Popup-Schutz. */
        w.open("https://wa.me/" + k.nummer.e164 + "?text=" + encodeURIComponent(buildText(a, "whatsapp")), "_blank", "noopener");
        try { w.sessionStorage.setItem(EXIT_KEY, "1"); } catch (eE2) {}
        return;
      }

      /* ── Weg 3: Festnetz — Speichern geht nicht, aber der Rückruf. Der Knopf heißt hier
         „Rückruf anfordern →", der Klick selbst ist die Anforderung (kein zweites Häkchen). ── */
      if (k.art === "nummer" && !k.nummer.whatsapp) {
        err.classList.remove("is-on");
        track("ergebnis_rueckruf_festnetz", {});
        starteRueckruf(k.nummer, "", a, rr ? "haekchen" : "knopf");
        try { w.sessionStorage.setItem(EXIT_KEY, "1"); } catch (eE3) {}
        return;
      }

      /* v551: Hauptfeld leer, aber Häkchen gesetzt und Nummer im Zusatzfeld — dann nur der
         Rückruf (vorher ging die Bitte hier verloren, Prüfung 25.09.). */
      if (rrNr && k.art === "leer") {
        err.classList.remove("is-on");
        starteRueckruf(rrNr, "", a);
        try { w.sessionStorage.setItem(EXIT_KEY, "1"); } catch (eE4) {}
        return;
      }

      err.classList.add("is-on");
      try { addr.focus(); } catch (eF) {}
    });
  }

  /* v468: Konvergenz-Bremse für die Positions-Nachführung (v406). Wenn ein
     zweiter Render-Zyklus (z. B. Doppel-Boot vor dem v468-Loader-Fix) die
     Sektionen laufend umsortiert, spielte die Nachführung Ping-Pong mit dem
     Renderer — die Speichern-Reihen flackerten dauerhaft. Max. 8 Bewegungen
     pro 10 s; danach bleibt die Reihe stehen, bis Ruhe einkehrt. */
  function iesMoveAllowed() {
    var log = (w.__IES_MOVES__ = w.__IES_MOVES__ || []);
    var now = Date.now();
    while (log.length && now - log[0] > 10000) log.shift();
    if (log.length >= 8) return false;
    log.push(now);
    return true;
  }

  function mountButtons() {
    var root = d.getElementById("isowiz-step4-root");
    if (!root) return;

    /* v407 (Björn: Kalkulator-Startscreen »Bedarfsrechner …« stand über der
       Ergebnisseite): Sobald die Ergebnisseite gerendert ist, darf der
       Start-Hero NIE sichtbar sein. Der Loader blendet ihn zwar aus, aber
       beim Boot über den sessionStorage-Intent (Lösungsseiten-Flow) kann
       ein fehlgeschlagener Fastlane-Versuch ihn per Rollback wieder
       anzeigen, während der zweite Boot-Pfad das Ergebnis darunter rendert.
       Dieser Wächter läuft mit jedem Beobachter-Tick und räumt das auf. */
    try {
      var heroEl = d.getElementById("isowiz-hero");
      if (heroEl && heroEl.style.display !== "none" && root.children.length > 0) {
        heroEl.style.display = "none";
      }
    } catch (eH) {}

    if (!getAnalysis()) return;

    /* v441 (Björn): Facebook-LEAD — UMGEZOGEN in v467. Das Lead feuerte hier
       bei JEDEM Ergebnisseiten-Aufruf (auch Resume/Rückkehr) und meldete
       denselben EUR-Wert mehrfach an Meta. Es lebt jetzt in
       26-isowiz-step-4.js (fireCalcValueEvents) hinter dem Signatur-Guard:
       exakt EINMAL pro neuer Berechnung, zusammen mit GA4 calculate_result
       und logr3 ergebnis_wert. Hier bewusst KEIN Aufruf mehr. */

    injectCSS();
    /* v400: Der Voice-Host wird jetzt von sec-01 SELBST gerendert (direkt
       unter der Flaschenzahl-Karte, Björns Wunschposition) — hier nur noch
       das Player-Script nachladen, sobald der Host im DOM ist. */
    if (!w.__ISO_VOICE_PLAYER__ && CFG.voiceScript && d.getElementById("ies-voice")) {
      loadScript(CFG.voiceScript).catch(function () {});
    }
    if (!d.getElementById("ies-top")) {
      /* v400: ies-voice liegt jetzt IM React-Hero (nicht als root-Kind) —
         als insertBefore-Anker taugt er nur, wenn er direktes root-Kind ist. */
      var vhEl = d.getElementById("ies-voice");
      var anchorEl = (vhEl && vhEl.parentNode === root) ? vhEl : (root.children && root.children[0]);
      var top = makeButtonRow("ies-top", "top");
      if (anchorEl && anchorEl.nextSibling) root.insertBefore(top, anchorEl.nextSibling);
      else root.appendChild(top);
    }
    if (!d.getElementById("ies-bottom")) {
      /* v525: unten eingeklappt statt als zweite volle Reihe. Spart ~360 px und
         nimmt der Seite die Wiederholung, ohne den Weg zu verlieren. */
      var fold = d.createElement("div");
      fold.className = "ies-fold";
      fold.id = "ies-fold";
      var fbtn = d.createElement("button");
      fbtn.type = "button";
      fbtn.className = "ies-fold-btn";
      fbtn.setAttribute("aria-expanded", "false");
      fbtn.innerHTML = '<span class="ies-fold-ic">\u25BC</span><span>Berechnung und Bohrplan sichern</span>';
      var fbody = d.createElement("div");
      fbody.className = "ies-fold-body";
      fbody.appendChild(makeButtonRow("ies-bottom", "bottom"));
      fbtn.addEventListener("click", function () {
        var auf = fold.classList.toggle("is-on");
        fbtn.setAttribute("aria-expanded", auf ? "true" : "false");
        if (auf) {
          track("ergebnis_save_fold_open", {});
          try { var f = fbody.querySelector(".ies-inl-addr"); if (f) f.focus(); } catch (e) {}
        }
      });
      fold.appendChild(fbtn);
      fold.appendChild(fbody);
      root.appendChild(fold);
    }

    /* v406 (Björn: »Speichern-Button unten manchmal doppelt«): Die Reihen
       werden gemountet, sobald die ERSTE Sektion steht — React rendert die
       übrigen Sektionen danach ans Root-Ende, wodurch Top- und Bottom-Reihe
       zeitweise direkt untereinander standen (wirkt doppelt) und unten keine
       mehr war. Fix: Position bei jedem Tick NACHFÜHREN — Knoten werden nur
       BEWEGT (nie neu erzeugt), Überzählige aus Alt-Zuständen entfernt. */
    var dupTop = d.querySelectorAll("#ies-top");
    for (var iT = 1; iT < dupTop.length; iT++) { try { dupTop[iT].parentNode.removeChild(dupTop[iT]); } catch (e) {} }
    var dupBot = d.querySelectorAll("#ies-bottom");
    for (var iB = 1; iB < dupBot.length; iB++) { try { dupBot[iB].parentNode.removeChild(dupBot[iB]); } catch (e) {} }
    var topEl = d.getElementById("ies-top");
    var botEl = d.getElementById("ies-bottom");
    var foldEl = d.getElementById("ies-fold");
    var firstSec = null;
    for (var iC = 0; iC < root.children.length; iC++) {
      var cEl = root.children[iC];
      if (cEl.id !== "ies-top" && cEl.id !== "ies-bottom" && cEl.id !== "ies-fold") { firstSec = cEl; break; }
    }
    /* v525.3 (Björn 09.09.): „nach dem Bohrplan machen wir erst die Speicher-
       funktion mit der E-Mail." Die Reihe steht also nicht mehr nach der ersten
       Sektion, sondern INNERHALB von sec-01 zwischen Sanierungsplan und Paket.
       sec-01 setzt dafür einen leeren Anker <div data-ies-anker="top">.
       Fehlt der Anker (ältere Fassung von sec-01), greift der alte Weg. */
    var anker = null;
    try { anker = d.querySelector('[data-ies-anker="top"]'); } catch (eA) {}
    if (topEl && anker && anker.parentNode && iesMoveAllowed()) {
      if (topEl.previousElementSibling !== anker) {
        try { anker.parentNode.insertBefore(topEl, anker.nextSibling); } catch (e) {}
      }
    } else if (topEl && firstSec && topEl.previousElementSibling !== firstSec && iesMoveAllowed()) {
      try { root.insertBefore(topEl, firstSec.nextSibling); } catch (e) {}
    }
    /* v525.1: Seit die untere Reihe im Aufklapper steckt, darf die Positions-
       korrektur NICHT mehr #ies-bottom selbst ans Root-Ende hängen — das riss
       sie aus der Hülle heraus und die Reihe stand wieder voll aufgeklappt da.
       Bewegt wird jetzt die Hülle; nur ohne Hülle greift der alte Weg. */
    if (foldEl) {
      if (botEl && botEl.parentNode !== foldEl.querySelector(".ies-fold-body")) {
        try { foldEl.querySelector(".ies-fold-body").appendChild(botEl); } catch (e) {}
      }
      /* v525.3 (Björn 09.09.): „…dann jetzt sichern und Berechnung neu starten,
         und das muss alles unten drunter sein in der richtigen Reihenfolge."
         Der Aufklapper gehört also VOR den Neustart-Knopf, nicht ans Seitenende
         dahinter. Der Knopf sitzt in sec-06; wir hängen die Hülle direkt davor
         in dessen Umschlag. Fällt der Knopf weg, greift der alte Weg (ans Ende). */
      if (iesMoveAllowed()) {
        var neustart = null;
        try { neustart = d.querySelector(".isocal-s6s6-restart-btn"); } catch (e) {}
        var ziel = neustart && neustart.parentNode ? neustart.parentNode : null;
        if (ziel && foldEl.nextElementSibling !== neustart) {
          try { ziel.insertBefore(foldEl, neustart); } catch (e) {}
        } else if (!ziel && root.lastElementChild !== foldEl) {
          try { root.appendChild(foldEl); } catch (e) {}
        }
      }
    } else if (botEl && root.lastElementChild !== botEl && iesMoveAllowed()) {
      try { root.appendChild(botEl); } catch (e) {}
    }
  }

  function observe() {
    var pending = false;
    function tick() {
      if (pending) return;
      pending = true;
      /* v406: setTimeout statt requestAnimationFrame — rAF feuert in
         Hintergrund-Tabs nicht und ließ pending hängen; dadurch liefen
         die Positions-Korrekturen (und späte Mounts) nie. */
      setTimeout(function () { pending = false; mountButtons(); }, 60);
    }
    try {
      /* v407: auch style-Änderungen beobachten — der Hero-Wächter muss
         feuern, wenn der Startscreen nur per display-Umschaltung
         wiederbelebt wird (Fastlane-Rollback macht genau das). */
      new MutationObserver(tick).observe(d.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["style"] });
    } catch (e) {}
    tick();
    /* Analysis kann minimal nach dem DOM da sein — kurze Nachläufe */
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      mountButtons();
      if (d.getElementById("ies-top") || tries > 20) clearInterval(iv);
    }, 500);
  }

  /* ══ v360: Export für weitere Einhängepunkte (Sticky, Drawer) ══ */
  w.IsoSave = { open: openSheet, hasAnalysis: function () { return !!getAnalysis(); } };

  /* ══ Ausstiegsfenster auf der Ergebnisseite (1× pro Sitzung) ══
     ENTWURF 27.09.2026: Das Fenster fragt jetzt, was zur Entscheidung noch fehlt,
     und beantwortet es sofort — statt allen dasselbe Hendrik-Angebot zu zeigen.
     Vier Antworten, jede fuehrt in eine eigene zweite Ansicht im selben Fenster:
       wand      → Hendrik (Anruf/WhatsApp/E-Mail in der Servicezeit, sonst Rueckruf)
       garantie  → Garantiebedingungen in drei Saetzen, zurueck zur Berechnung
       anwendung → Bauforum24-Kurzvideo (erst auf Klick geladen), zurueck
       spaeter   → bestehendes Speichern-Fenster (openSheet("exit"))
     Ausgangslage (Logr3 14.08.–26.09.): 2.043 Anzeigen, 57 % weggeklickt, 38 %
     ohne Reaktion, nur 2,1 % Hendrik-Kontakt und 2,1 % Speichern.
     Kanon: Sie-Form, "Mauerwerks-Abdichtungsexperte", "Servicezeit" statt
     "erreichbar" (Feiertage kennt die Uhr nicht), "ob" statt "dass", kein
     "kostenlos" am 0170-Anruf (Mobilfunk) — nur am Rueckruf. Keine Kundenergebnisse:
     die zwei Vorher-Nachher-Faelle haben weder Datum noch Einwilligung.
     Messung: Logr3 liefert keine Nutzlast und keine Sitzungs-ID. Die Antwort
     und der Vorher-Zustand stehen deshalb im Ereignisnamen
     (ergebnis_exit_grund_<wahl>__<zustand>), die Antwort zusaetzlich als
     Warenkorb-Merkmal isofin_exit an der Bestellung. ══ */
  var EXIT_KEY = "__ISO_EXIT_SAVE_SHOWN__";
  var EXIT_WAHL_KEY = "__ISO_EXIT_GRUND__";
  var exitEl = null;
  var HENDRIK_TEL = "+491708449472";
  var HENDRIK_TEL_TEXT = "0170 844 94 72";
  var HENDRIK_WA = "https://wa.me/491708449472";
  var HENDRIK_MAIL = "anfrage@isofin.de";
  var HENDRIK_FOTO = "https://cdn.shopify.com/s/files/1/0846/5550/5691/files/2026-hendrik-fluegge-blau-avatar-mittel-300px.jpg?v=1790351554&width=120";
  var BF24_ID = "9On7tGo81Ug";
  var exitGezeigt = false;   /* Rueckfall, falls sessionStorage gesperrt ist */

  /* Mauerwerk in eine Formulierung bringen, die im Satz "fuer Ihr ___" traegt.
     Unbekannt/unsicher faellt bewusst auf das neutrale "Mauerwerk" zurueck, damit nie
     eine Steinart behauptet wird, die der Kunde gar nicht angegeben hat. */
  function mauerwerkPhrase(a) {
    var t = String((a && a.masonryType) || "").toLowerCase();
    if (t.indexOf("hohl") >= 0 || t.indexOf("loch") >= 0) return "Hohlblock-Mauerwerk";
    if (t.indexOf("kalksand") >= 0) return "Kalksandstein-Mauerwerk";
    if (t.indexOf("naturstein") >= 0 || t.indexOf("bruchstein") >= 0) return "Natursteinmauerwerk";
    if (t.indexOf("beton") >= 0) return "Beton";
    if (t.indexOf("ziegel") >= 0) return "Ziegelmauerwerk";
    return "Mauerwerk";
  }

  /* Servicezeit — EINE Wahrheit auf der ganzen Seite: der Zustand der
     Announcement-Bar, sonst dieselbe Regel als Rueckfall. */
  var OEFFNUNG_TEXT = "Mo–Fr 9–20 Uhr · Sa 10–15 Uhr";
  var OEFFNUNG_HTML = '<span style="white-space:nowrap">Mo–Fr 9–20&nbsp;Uhr</span> · <span style="white-space:nowrap">Sa 10–15&nbsp;Uhr</span>';
  function istErreichbar() {
    try {
      var el = d.querySelector(".isofin-ab-avail-open, .isofin-ab-avail-closed");
      if (el) return el.classList.contains("isofin-ab-avail-open");
    } catch (_eDom) {}
    try {
      var g = new Date(new Date().toLocaleString("en-US", { timeZone: "Europe/Berlin" }));
      var tag = g.getDay(), std = g.getHours();
      if (tag >= 1 && tag <= 5) return std >= 9 && std < 20;
      if (tag === 6) return std >= 10 && std < 15;
      return false;
    } catch (e) {
      return true;
    }
  }

  /* ── Vorher-Zustand: was hat die Person vor dem Fenster schon genutzt? ──
     Eigene, kleine Beobachtung hier, weil die Sicht-Zaehler der Seite ihren
     Zustand nicht nach aussen geben. Pro Antwort zaehlt nur das passende Modul
     (3 Zustaende), sonst explodiert die Zahl der Ereignisnamen. */
  var vorher = { hendrikSicht: false, hendrikKlick: false, garantieKlick: false,
    garantieKrone: false, videoKlick: false };
  function beobachteVorher() {
    try {
      d.addEventListener("click", function (e) {
        var t = e.target && e.target.closest ? e.target : null;
        if (!t || (exitEl && exitEl.contains(t))) return;
        if (t.closest(".isocal-s6v2-hp, .isocal-s6v2-hk, .isocal-s6v2-dw, .isocal-s6v2-hbw")) {
          if (t.closest("a,button")) vorher.hendrikKlick = true;
        }
        if (t.closest('a[href*="garantie"], #isocal-garantie-modal')) vorher.garantieKlick = true;
        if (t.closest(".isocal-s6v2-ytt")) vorher.videoKlick = true;
      }, true);
    } catch (e) {}
    if (!("IntersectionObserver" in w)) return;
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (en) {
        if (!en.isIntersecting) return;
        var art = en.target.getAttribute("data-iex-vorher");
        if (art === "hendrik") vorher.hendrikSicht = true;
        if (art === "krone") vorher.garantieKrone = true;
        io.unobserve(en.target);
      });
    }, { threshold: 0.35 });
    /* Das Ergebnis erscheint erst nach Schritt 1–3 (oder nach dem Wiederherstellen):
       so lange nachfassen, bis beide Elemente gebunden sind (hoechstens 20 Minuten). */
    var versuche = 0, gebunden = {};
    (function binde() {
      if (d.getElementById("isowiz-step4-root")) {
        [[".isocal-s6v2-hp, .isocal-s6v2-hk, .isocal-s6v2-dw, .isocal-s6v2-hbw", "hendrik"],
         [".isocal-s6vs-krone, .isocal-s6vs-krone-t", "krone"]].forEach(function (p) {
          var el = d.querySelector(p[0]);
          if (el && !el.getAttribute("data-iex-vorher")) {
            el.setAttribute("data-iex-vorher", p[1]);
            io.observe(el);
            gebunden[p[1]] = true;
          }
        });
      }
      versuche += 1;
      if (!(gebunden.hendrik && gebunden.krone) && versuche < 800) setTimeout(binde, 1500);
    })();
  }
  /* Kurzcodes fuer den Namen: n = nicht gesehen, g = gesehen, k = geklickt/geoeffnet */
  function vorherZustand(wahl) {
    if (wahl === "wand") return vorher.hendrikKlick ? "k" : (vorher.hendrikSicht ? "g" : "n");
    if (wahl === "garantie") return vorher.garantieKlick ? "k" : (vorher.garantieKrone ? "g" : "n");
    if (wahl === "anwendung") return vorher.videoKlick ? "k" : "n";
    if (wahl === "spaeter") {
      var bp = false;
      try { bp = w.sessionStorage.getItem("__ISO_BP_OPEN__") === "1"; } catch (e) {}
      return bp ? "k" : "n";
    }
    return "n";
  }

  /* Antwort merken: fuer die Rueckkehr zum Kaufknopf in derselben Sitzung und
     als Warenkorb-Merkmal an der Bestellung (Datum fuer "Kauf binnen x Tagen"). */
  function merkeWahl(wahl, zustand) {
    try { w.sessionStorage.setItem(EXIT_WAHL_KEY, wahl); } catch (e) {}
    try {
      var tag = new Intl.DateTimeFormat("de-DE", { timeZone: "Europe/Berlin", day: "2-digit",
        month: "2-digit", year: "2-digit" }).format(new Date()).replace(/\./g, "");
      setCartAttribute("isofin_exit", wahl + "|" + zustand + "|" + tag);
    } catch (e) {}
  }
  function wireRueckkehr() {
    d.addEventListener("click", function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (!t.closest(".isocal-s6v2-cta-btn, .isocal-s6vs-cta, .isocal-s6v2-sticky-cta-btn")) return;
      var wahl = null;
      try { wahl = w.sessionStorage.getItem(EXIT_WAHL_KEY); } catch (e2) {}
      if (wahl) track("ergebnis_kauf_klick_nachexit_" + wahl, {});
    }, true);
  }

  var ICON = {
    schild: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>',
    play: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.5v13a1 1 0 0 0 1.5.9l10.2-6.5a1 1 0 0 0 0-1.7L9.5 4.6A1 1 0 0 0 8 5.5z"/></svg>',
    merken: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 3h12a1 1 0 0 1 1 1v17l-7-4-7 4V4a1 1 0 0 1 1-1z"/></svg>',
    tel: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2z"/></svg>'
  };

  function buildExit() {
    if (exitEl) return;
    injectCSS();
    var css = d.createElement("style");
    css.textContent = "" +
      ".iex-ov{position:fixed;inset:0;background:rgba(17,17,17,.45);z-index:2147483250;display:flex;align-items:center;justify-content:center;padding:16px;opacity:0;visibility:hidden;transition:opacity .18s}" +
      ".iex-ov.is-on{opacity:1;visibility:visible}" +
      ".iex-card{box-sizing:border-box;background:#fff;border-radius:16px;max-width:440px;width:100%;padding:20px 18px 14px;box-shadow:0 18px 50px rgba(0,0,0,.25);font-family:Rubik,-apple-system,sans-serif;position:relative;max-height:calc(100dvh - 32px);overflow-y:auto;-webkit-overflow-scrolling:touch;color:#1a1a1a}" +
      ".iex-card *{box-sizing:border-box}" +
      ".iex-x{position:absolute;top:9px;right:9px;width:44px;height:44px;border:1px solid #e4e0d9;border-radius:50%;background:#fff;color:#1a1a1a;font-size:19px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;z-index:2}" +
      ".iex-x:hover{background:#f2f1ef}" +
      ".iex-ansicht{display:none}.iex-ansicht.is-on{display:block}" +
      ".iex-kicker{margin:2px 50px 6px 0;font-size:13px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;color:#D6001C;display:flex;align-items:center;gap:6px}" +
      ".iex-kicker::before{content:'';width:8px;height:8px;border-radius:50%;background:#1E7A34;flex:0 0 8px}" +
      ".iex-title{margin:0 50px 6px 0;font-size:19px;font-weight:700;color:#1a1a1a;line-height:1.28}" +
      ".iex-ansicht:not([data-ansicht=frage]) .iex-title{margin-right:0}" +
      ".iex-text{margin:0 0 14px;font-size:14.5px;line-height:1.55;color:#5f5b56}" +
      ".iex-text b{color:#1a1a1a;font-weight:600}" +
      /* Antwort-Knoepfe: ganze Zeile tippbar, Pfeil als klare Affordanz (45+) */
      ".iex-wahlen{display:grid;gap:8px;margin:0 0 4px}" +
      ".iex-wahl{display:grid;grid-template-columns:40px 1fr 18px;gap:11px;align-items:center;width:100%;min-height:62px;padding:10px 12px;background:#fff;border:1.5px solid #e1ddd6;border-radius:12px;cursor:pointer;font-family:inherit;text-align:left;color:#1a1a1a;transition:border-color .15s,background .15s}" +
      ".iex-wahl:hover{border-color:#D6001C;background:#fff8f8}" +
      ".iex-wahl-ic{width:40px;height:40px;border-radius:50%;display:flex;align-items:center;justify-content:center;background:#f4f2ee;color:#1a1a1a;overflow:hidden}" +
      ".iex-wahl-ic svg{width:20px;height:20px}" +
      ".iex-wahl-ic img{width:40px;height:40px;object-fit:cover;display:block}" +
      ".iex-wahl-ic.is-rot{background:#fdecee;color:#D6001C}" +
      ".iex-wahl-ic.is-gruen{background:#e9f5ec;color:#1E7A34}" +
      ".iex-wahl b{display:block;font-size:15.5px;font-weight:700;line-height:1.28}" +
      ".iex-wahl small{display:block;font-size:13px;color:#5f5b56;line-height:1.38;margin-top:2px}" +
      ".iex-pfeil{font-size:22px;line-height:1;color:#D6001C;font-weight:700}" +
      ".iex-zurueck{display:inline-flex;align-items:center;gap:4px;min-height:44px;margin:-6px 0 4px -4px;padding:0 6px;background:none;border:0;color:#5f5b56;font:600 14px Rubik,-apple-system,sans-serif;cursor:pointer}" +
      ".iex-zurueck:hover{color:#1a1a1a}" +
      ".iex-head{display:flex;gap:11px;align-items:center;margin:0 0 12px}" +
      ".iex-fotowrap{position:relative;flex:0 0 52px;width:52px;height:52px}" +
      ".iex-foto{width:52px;height:52px;border-radius:50%;object-fit:cover;border:2.5px solid #D6001C;background:#e8e4dd;display:block}" +
      ".iex-punkt{position:absolute;right:-1px;bottom:-1px;width:14px;height:14px;border-radius:50%;background:#1E7A34;border:2px solid #fff;animation:iexPuls 2.4s ease-in-out infinite}" +
      "@keyframes iexPuls{0%,100%{box-shadow:0 0 0 0 rgba(30,122,52,.55)}70%{box-shadow:0 0 0 7px rgba(30,122,52,0)}}" +
      ".iex-name{font-size:15.5px;font-weight:700;line-height:1.25;display:block;color:#1a1a1a}" +
      ".iex-rolle{font-size:13px;color:#5f5b56;display:block}" +
      ".iex-status{font-size:13px;font-weight:600;display:block;margin-top:2px;color:#1E7A34}" +
      ".iex-status.is-zu{color:#5f5b56;font-weight:500}" +
      ".iex-main{display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;min-height:54px;padding:13px 18px;background:#D6001C;border:none;border-radius:12px;color:#fff;font-size:16.5px;font-weight:700;cursor:pointer;font-family:inherit;line-height:1.25;text-decoration:none;text-align:center}" +
      ".iex-main:hover{background:#B8001A;color:#fff}" +
      ".iex-main small{font-size:13px;font-weight:400;opacity:.95;margin-top:2px}" +
      ".iex-zwei{display:grid;grid-template-columns:1fr 1fr;gap:8px;margin:9px 0 0}" +
      ".iex-wa,.iex-mail{display:flex;align-items:center;justify-content:center;width:100%;min-height:48px;padding:11px 10px;background:#fff;border-radius:12px;font-size:15px;font-weight:700;cursor:pointer;font-family:inherit;text-align:center;text-decoration:none}" +
      ".iex-wa{border:1.5px solid #25d366;color:#1a8a43}" +
      ".iex-wa:hover{background:rgba(37,211,102,.08);color:#1a8a43}" +
      ".iex-mail{border:1.5px solid #d6d3ce;color:#4a4744}" +
      ".iex-mail:hover{background:#f7f5f2;color:#1a1a1a}" +
      ".iex-link{display:flex;align-items:center;justify-content:center;gap:4px;width:100%;min-height:44px;margin:6px 0 0;padding:10px 12px;background:transparent;border:0;color:#D6001C;font-size:14.5px;font-weight:700;cursor:pointer;font-family:inherit;text-align:center;text-decoration:none}" +
      ".iex-link:hover{text-decoration:underline;text-underline-offset:2px}" +
      ".iex-sub{display:block;width:100%;margin:8px 0 0;padding:12px 16px;min-height:44px;background:transparent;border:0;color:#5f5b56;font-size:14px;font-weight:600;cursor:pointer;font-family:inherit;text-align:center;text-decoration:underline;text-underline-offset:2px}" +
      ".iex-sub:hover{color:#1a1a1a}" +
      ".iex-punkte{list-style:none;margin:0 0 14px;padding:0;display:grid;gap:8px}" +
      ".iex-punkte li{display:grid;grid-template-columns:20px 1fr;gap:8px;font-size:14.5px;line-height:1.45;color:#3d3a37}" +
      ".iex-punkte li::before{content:'\\2713';display:flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:50%;background:#e9f5ec;color:#1E7A34;font-size:12px;font-weight:700;margin-top:1px}" +
      ".iex-wichtig{margin:-4px 0 14px;padding:9px 11px;border-radius:10px;background:#fff7e6;border:1px solid #f1d9a6;font-size:14px;line-height:1.45;color:#4a3b12}" +
      ".iex-wichtig b{color:#1a1a1a}" +
      ".iex-garantie-kopf{display:flex;gap:11px;align-items:center;margin:0 0 10px}" +
      ".iex-garantie-ic{flex:0 0 46px;width:46px;height:46px;border-radius:50%;background:#fdecee;color:#D6001C;display:flex;align-items:center;justify-content:center}" +
      ".iex-garantie-ic svg{width:24px;height:24px}" +
      ".iex-video{position:relative;width:100%;aspect-ratio:16/9;border-radius:12px;overflow:hidden;background:#111;margin:0 0 8px}" +
      ".iex-video-btn{position:absolute;inset:0;width:100%;height:100%;padding:0;border:0;cursor:pointer;background:#111}" +
      ".iex-video-btn img{width:100%;height:100%;object-fit:cover;display:block;opacity:.9}" +
      ".iex-video-play{position:absolute;left:50%;top:50%;width:62px;height:62px;margin:-31px 0 0 -31px;border-radius:50%;background:#D6001C;color:#fff;display:flex;align-items:center;justify-content:center;box-shadow:0 6px 18px rgba(0,0,0,.35)}" +
      ".iex-video-play svg{width:26px;height:26px;margin-left:3px}" +
      ".iex-video iframe{position:absolute;inset:0;width:100%;height:100%;border:0;display:block}" +
      ".iex-quelle{margin:0 0 6px;font-size:13px;color:#5f5b56}" +
      ".iex-hinweis{margin:0 0 14px;font-size:13px;line-height:1.45;color:#5f5b56}" +
      ".iex-hinweis a{color:#D6001C;font-weight:600}" +
      ".iex-x:focus-visible,.iex-wahl:focus-visible,.iex-main:focus-visible,.iex-wa:focus-visible,.iex-mail:focus-visible,.iex-link:focus-visible,.iex-sub:focus-visible,.iex-zurueck:focus-visible,.iex-video-btn:focus-visible{outline:3px solid #D6001C;outline-offset:2px}" +
      "@media (max-width:400px){" +
        ".iex-ov{padding:10px;align-items:flex-end}" +
        ".iex-card{padding:16px 14px 12px;border-radius:16px 16px 12px 12px;max-height:calc(100dvh - 20px)}" +
        ".iex-title{font-size:18px}" +
        ".iex-text{font-size:14px}" +
        ".iex-wahl{min-height:60px;padding:9px 10px;gap:10px}" +
        ".iex-wahl b{font-size:15px}" +
        ".iex-main{font-size:15.5px;padding:12px 14px}" +
      "}" +
      "@media (max-height:560px){" +
        ".iex-card{padding-top:14px}" +
        ".iex-text{margin-bottom:10px}" +
        ".iex-wahl{min-height:54px}" +
      "}" +
      "@media (prefers-reduced-motion:reduce){.iex-ov{transition:none}.iex-punkt{animation:none}}";
    d.head.appendChild(css);

    var a = getAnalysis() || {};
    var mauer = mauerwerkPhrase(a);
    var offen = istErreichbar();
    var sperre = a.barrierLabel
      || ((a.barrierType === "vertical" || a.moistureType === "side") ? "Flächensperre" : "Horizontalsperre");
    var flaschen = a.calculatedBottles || 0;
    var betreff = encodeURIComponent("Frage vor der Bestellung — " + sperre
      + (flaschen ? ", " + flaschen + " Flaschen" : ""));
    var waText = encodeURIComponent("Hallo Herr Flügge, ich habe gerade berechnet: "
      + (flaschen ? flaschen + " Flaschen, " : "") + sperre + ". Können Sie meine Berechnung kurz mit mir durchgehen?");
    var thumb = (w.ISOWIZ_ASSETS_BASE || "") + "iso-yt-bf24-horizontalsperre.jpg";

    var kopfHendrik = '<div class="iex-head">' +
        '<span class="iex-fotowrap"><img class="iex-foto" src="' + HENDRIK_FOTO + '" alt="Hendrik Flügge, Mauerwerks-Abdichtungsexperte" width="52" height="52" loading="lazy" decoding="async">' +
          (offen ? '<span class="iex-punkt" aria-hidden="true"></span>' : '') + '</span>' +
        '<span>' +
          '<span class="iex-name">Hendrik Flügge</span>' +
          '<span class="iex-rolle">Mauerwerks-Abdichtungsexperte</span>' +
          '<span class="iex-status' + (offen ? '' : ' is-zu') + '">' +
            (offen ? 'Jetzt ist Servicezeit' : 'Servicezeit: ' + OEFFNUNG_HTML) + '</span>' +
        '</span>' +
      '</div>';

    exitEl = d.createElement("div");
    exitEl.className = "iex-ov";
    exitEl.setAttribute("role", "dialog");
    exitEl.setAttribute("aria-modal", "true");
    exitEl.setAttribute("aria-label", "Was fehlt Ihnen noch für Ihre Entscheidung?");
    exitEl.innerHTML = "" +
      '<div class="iex-card">' +
      '<button type="button" class="iex-x" aria-label="Schließen">✕</button>' +

      /* ── Ansicht 1: die Frage ── */
      '<div class="iex-ansicht is-on" data-ansicht="frage">' +
        '<p class="iex-kicker">Ihre Berechnung ist fertig</p>' +
        '<p class="iex-title">Was fehlt Ihnen noch für Ihre Entscheidung?</p>' +
        '<p class="iex-text">Wählen Sie, was am ehesten passt.</p>' +
        '<div class="iex-wahlen">' +
          '<button type="button" class="iex-wahl" data-wahl="wand">' +
            '<span class="iex-wahl-ic"><img src="' + HENDRIK_FOTO + '" alt="" width="40" height="40" loading="lazy" decoding="async"></span>' +
            '<span><b>Zusätzlich persönlich von Hendrik bestätigen lassen</b><small>Unser Mauerwerks-Abdichtungsexperte geht Ihre Berechnung mit Ihnen durch</small></span>' +
            '<span class="iex-pfeil" aria-hidden="true">›</span></button>' +
          /* v561 (Adrian 28.09.): nur Hendrik und Speichern. Garantie-Frage raus – „die Wirkung kann nicht
             verloren gehen“; Anwendungsvideo vorerst raus. Die Ansichten dazu bleiben im Code, sind aber
             nicht mehr erreichbar. */
          '<button type="button" class="iex-wahl" data-wahl="spaeter">' +
            '<span class="iex-wahl-ic is-gruen">' + ICON.merken + '</span>' +
            '<span><b>Ergebnis für später speichern</b><small>Berechnung und Bohrplan per E-Mail oder WhatsApp an Sie selbst</small></span>' +
            '<span class="iex-pfeil" aria-hidden="true">›</span></button>' +
        '</div>' +
        '<button type="button" class="iex-sub" data-keins="1">Nichts davon – zurück zur Berechnung</button>' +
      '</div>' +

      /* ── Ansicht 2a: Hendrik ── */
      '<div class="iex-ansicht" data-ansicht="wand">' +
        '<button type="button" class="iex-zurueck">‹ Zurück</button>' +
        kopfHendrik +
        /* v561 (Adrian 28.09.): zurück zur persönlichen Zusatz-Bestätigung (Björns Fassung 14.08.) –
           kein Zweifel „passt es überhaupt?“, sondern Hendrik als persönliche Absicherung obendrauf. */
        '<p class="iex-title">Doppelt abgesichert loslegen</p>' +
        '<p class="iex-text">Ihre Berechnung ist <b>technisch freigegeben</b>. Zusätzlich geht Hendrik Flügge, ' +
          'unser Mauerwerks-Abdichtungsexperte, sie persönlich mit Ihnen durch und klärt offene Fragen – ' +
          '<b>damit Sie Ihre ' + sperre + ' selbst erstellen können, abgesichert durch unsere lebenslange Wirksamkeits-Garantie.</b></p>' +
        (offen
          ? '<a class="iex-main" data-kanal="call" href="tel:' + HENDRIK_TEL + '">Bestätigung von Hendrik holen' +
              '<small>' + HENDRIK_TEL_TEXT + ' – direkt am Telefon, ohne Verpflichtung</small></a>'
          : '<a class="iex-main" data-kanal="rueckruf" href="/pages/rueckruf-anfragen">Rückruf von Hendrik anfordern' +
              '<small>Kostenlos · Hendrik ruft Sie zurück</small></a>') +
        '<div class="iex-zwei">' +
          '<a class="iex-wa" data-kanal="whatsapp" href="' + HENDRIK_WA + '?text=' + waText + '" target="_blank" rel="noopener">WhatsApp</a>' +
          '<a class="iex-mail" data-kanal="email" href="mailto:' + HENDRIK_MAIL + '?subject=' + betreff + '">E-Mail</a>' +
        '</div>' +
        (offen ? '<a class="iex-link" data-kanal="rueckruf" href="/pages/rueckruf-anfragen">Lieber Rückruf anfordern – kostenlos ›</a>' : '') +
      '</div>' +

      /* ── Ansicht 2b: Garantie (Wortlaut nach /pages/garantie) ── */
      '<div class="iex-ansicht" data-ansicht="garantie">' +
        '<button type="button" class="iex-zurueck">‹ Zurück</button>' +
        '<div class="iex-garantie-kopf"><span class="iex-garantie-ic">' + ICON.schild + '</span>' +
          '<p class="iex-title" style="margin:0">Bei Wirkungsverlust liefern wir kostenlosen Ersatz</p></div>' +
        '<p class="iex-text">Für Isofin® gilt unsere <b>lebenslange Wirksamkeits-Garantie</b>. ' +
          'Kommt es zu einem Wirkungsverlust, liefern wir Ihnen nach den Garantiebedingungen kostenlosen Ersatz.</p>' +
        '<ul class="iex-punkte">' +
          '<li>Die Garantieurkunde liegt Ihrer Lieferung bei.</li>' +
          '<li>Alle Bedingungen stehen in der Urkunde.</li>' +
        '</ul>' +
        '<p class="iex-wichtig"><b>Wichtig:</b> Senden Sie die ausgefüllte Urkunde innerhalb von 30 Tagen nach dem Kauf per E‑Mail und per Post an uns.</p>' +
        '<button type="button" class="iex-main" data-zurueck-kauf="garantie">Zurück zu meiner Berechnung</button>' +
        '<button type="button" class="iex-link" data-geh="wand">Vorher mit Hendrik sprechen ›</button>' +
        '<a class="iex-link" data-garantie-link="1" href="/pages/garantie" target="_blank" rel="noopener" style="margin-top:0">Garantie und MPA-Prüfbericht ansehen ›</a>' +
      '</div>' +

      /* ── Ansicht 2c: Anwendung im Video (Zwei-Klick: erst auf Tippen geladen) ── */
      '<div class="iex-ansicht" data-ansicht="anwendung">' +
        '<button type="button" class="iex-zurueck">‹ Zurück</button>' +
        '<p class="iex-title">So läuft die Anwendung ab</p>' +
        '<div class="iex-video">' +
          '<button type="button" class="iex-video-btn" aria-label="Video abspielen">' +
            '<img src="' + thumb + '" alt="Bauforum24-Kurzvideo über die flüssige Horizontalsperre mit Isofin" loading="lazy">' +
            '<span class="iex-video-play">' + ICON.play + '</span></button>' +
        '</div>' +
        '<p class="iex-quelle">Quelle: YouTube / Bauforum24</p>' +
        '<p class="iex-hinweis">Hinweis: Inzwischen gilt die <a href="/pages/garantie" target="_blank" rel="noopener">lebenslange Wirksamkeits-Garantie</a> – auch wenn ältere Beiträge noch 20 Jahre nennen.</p>' +
        (sperre === "Flächensperre"
          ? '<p class="iex-text">Das Video zeigt die Horizontalsperre. Wie Sie bei der Flächensperre bohren, steht in Ihrem persönlichen Bohrplan.</p>'
          : '<p class="iex-text">Abstände, Bohrtiefe und Reihenfolge für Ihre Wand stehen in Ihrem persönlichen Bohrplan.</p>') +
        '<button type="button" class="iex-main" data-zurueck-kauf="anwendung">Zurück zu meiner Berechnung</button>' +
      '</div>' +

      "</div>";
    d.body.appendChild(exitEl);

    var aktuelleWahl = null;
    var videoBox = exitEl.querySelector(".iex-video");
    var videoKnopfHtml = videoBox ? videoBox.innerHTML : "";
    function videoStopp() {
      if (videoBox && videoBox.querySelector("iframe")) {
        videoBox.innerHTML = videoKnopfHtml;
        verdrahteVideo();
      }
    }
    function zeige(name) {
      if (name !== "anwendung") videoStopp();
      var alle = exitEl.querySelectorAll(".iex-ansicht");
      for (var i = 0; i < alle.length; i++) {
        alle[i].classList.toggle("is-on", alle[i].getAttribute("data-ansicht") === name);
      }
      try { exitEl.querySelector(".iex-card").scrollTop = 0; } catch (e) {}
      var fokus = exitEl.querySelector('.iex-ansicht.is-on .iex-zurueck, .iex-ansicht.is-on .iex-wahl');
      try { if (fokus) fokus.focus({ preventScroll: true }); } catch (e) {}
    }

    function closeExit(via) {
      exitEl.classList.remove("is-on");
      d.removeEventListener("keydown", aufEscape);
      try { d.body.style.overflow = ""; } catch (_eS) {}
      videoStopp();
      if (via) {
        track("ergebnis_save_exit_close", { via: via });
        track("ergebnis_exit_hendrik_close_" + via, {});
        if (aktuelleWahl) track("ergebnis_exit_grund_" + aktuelleWahl + "_zu_" + via, {});
      }
    }
    function aufEscape(e) {
      if (e.key === "Escape" || e.key === "Esc") { closeExit("esc"); }
    }
    d.addEventListener("keydown", aufEscape);
    exitEl.addEventListener("click", function (e) { if (e.target === exitEl) closeExit("overlay"); });
    exitEl.querySelector(".iex-x").addEventListener("click", function () { closeExit("x"); });

    /* Antworten */
    var wahlen = exitEl.querySelectorAll(".iex-wahl");
    for (var i = 0; i < wahlen.length; i++) {
      wahlen[i].addEventListener("click", function () {
        var wahl = this.getAttribute("data-wahl");
        var zustand = vorherZustand(wahl);
        /* nur die ERSTE Antwort zaehlt als Grund; Zurueck + andere Wahl = _auch_ */
        if (!aktuelleWahl) {
          track("ergebnis_exit_grund_" + wahl, {});
          track("ergebnis_exit_grund_" + wahl + "__" + zustand, {});
          merkeWahl(wahl, zustand);
        } else if (wahl !== aktuelleWahl) {
          track("ergebnis_exit_grund_auch_" + wahl, {});
        }
        aktuelleWahl = aktuelleWahl || wahl;
        if (wahl === "spaeter") {
          /* Bestandsereignis beibehalten, damit die Speichern-Zahl vergleichbar bleibt */
          track("ergebnis_exit_hendrik_save", {});
          closeExit(null);   /* raeumt Escape-Zuhoerer, Scroll-Sperre und Video mit ab */
          openSheet("exit");
          return;
        }
        zeige(wahl);
      });
    }
    exitEl.querySelector("[data-keins]").addEventListener("click", function () {
      track(aktuelleWahl ? "ergebnis_exit_grund_auch_keins" : "ergebnis_exit_grund_keins", {});
      closeExit("keins");
    });
    var zurueck = exitEl.querySelectorAll(".iex-zurueck");
    for (var z = 0; z < zurueck.length; z++) {
      zurueck[z].addEventListener("click", function () { zeige("frage"); });
    }
    exitEl.querySelector('[data-geh="wand"]').addEventListener("click", function () {
      track("ergebnis_exit_garantie_zu_hendrik", {});
      zeige("wand");
    });
    var zurueckKauf = exitEl.querySelectorAll("[data-zurueck-kauf]");
    for (var k = 0; k < zurueckKauf.length; k++) {
      zurueckKauf[k].addEventListener("click", function () {
        track("ergebnis_exit_zurueck_" + this.getAttribute("data-zurueck-kauf"), {});
        closeExit(null);
      });
    }
    exitEl.querySelector("[data-garantie-link]").addEventListener("click", function () {
      track("ergebnis_exit_garantie_link", {});
    });

    /* Kontaktwege: Bestandsnamen weiterverwenden, damit die Zeitreihe haelt */
    var kanaele = exitEl.querySelectorAll("[data-kanal]");
    for (var j = 0; j < kanaele.length; j++) {
      kanaele[j].addEventListener("click", function () {
        var kanal = this.getAttribute("data-kanal");
        var name = { call: "ergebnis_exit_hendrik_call", whatsapp: "ergebnis_exit_hendrik_whatsapp",
          email: "ergebnis_exit_hendrik_email", rueckruf: "ergebnis_exit_hendrik_rueckruf" }[kanal];
        if (name) track(name, { bottles: flaschen });
      });
    }

    /* Video erst auf Tippen laden (kein YouTube-Aufruf ohne Handlung) */
    function verdrahteVideo() {
      var knopf = exitEl.querySelector(".iex-video-btn");
      if (!knopf) return;
      knopf.addEventListener("click", function () {
        track("ergebnis_exit_video_play", {});
        videoBox.innerHTML = '<iframe title="Flüssige Horizontalsperre? (Isofin) — Bauforum24"' +
          ' src="https://www.youtube-nocookie.com/embed/' + BF24_ID + '?autoplay=1&rel=0&modestbranding=1&playsinline=1&iv_load_policy=3"' +
          ' allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"' +
          ' allowfullscreen referrerpolicy="origin-when-cross-origin"></iframe>';
      });
    }
    verdrahteVideo();
  }

  /* Gemeinsamer Torwaechter fuer alle Ausloeser. Liefert true, wenn gezeigt. */
  function vielleichtExitZeigen(ausloeser) {
    var shown = exitGezeigt;
    try { shown = shown || w.sessionStorage.getItem(EXIT_KEY) === "1"; } catch (err) {}
    if (shown) return false;
    /* Nicht in einem verdeckten Tab aufgehen — sonst zaehlt "gezeigt", was niemand sah */
    if (d.visibilityState && d.visibilityState !== "visible") return false;
    if (!d.getElementById("isowiz-step4-root")) return false;
    if (!getAnalysis()) return false;
    if (sheetEl && sheetEl.classList.contains("is-on")) return false;
    exitGezeigt = true;
    try { w.sessionStorage.setItem(EXIT_KEY, "1"); } catch (err) {}
    buildExit();
    /* Bestandsereignisse bleiben (Zeitreihe seit 02.07. bzw. 14.08.) */
    track("ergebnis_save_exit_shown", {});
    track(istErreichbar() ? "ergebnis_exit_hendrik_shown_open" : "ergebnis_exit_hendrik_shown_closed", {});
    /* neu: Fassung und Ausloeser im Namen */
    track("ergebnis_exit_frage_shown", {});
    track("ergebnis_exit_ausloeser_" + (ausloeser || "unbekannt"), {});
    exitEl.classList.add("is-on");
    try { d.body.style.overflow = "hidden"; } catch (_eS) {}
    return true;
  }

  function istBreitbild() {
    return !!(w.matchMedia && w.matchMedia("(min-width: 768px)").matches);
  }

  /* Desktop: Maus verlaesst das Fenster nach oben (Richtung Tab-Leiste). */
  function wireExitIntent() {
    if (!CFG.loader) return;                                   /* nur Ergebnisseite/Kalkulator */
    d.addEventListener("mouseout", function (e) {
      /* im Handler geprueft, damit Fenster-Vergroessern nach dem Laden zaehlt */
      if (!istBreitbild()) return;
      if (e.relatedTarget || e.toElement) return;              /* nur echtes Verlassen des Fensters */
      if (e.clientY > 0) return;                               /* nur nach oben */
      vielleichtExitZeigen("maus");
    });
  }

  /* Handy: es gibt kein "Maus verlaesst das Fenster". Laut Geraetedaten sind rund
     83 % der Klicks mobil — ohne eigenen Ausloeser erreicht das Popup nur ein
     Sechstel der Besucher. Zwei Signale, beide bewusst zurueckhaltend:
       1. deutlicher Rueck-Scroll nach oben (typisches Abbruchsignal), fruehestens
          nach 20 Sekunden, damit niemand beim Lesen ueberfallen wird
       2. Rueckfall: 45 Sekunden ohne jede Interaktion
     Beide laufen durch denselben Torwaechter, also weiterhin hoechstens einmal
     pro Sitzung. */
  function wireExitIntentMobil() {
    if (!CFG.loader) return;
    if (istBreitbild()) return;
    var letzteY = w.scrollY || 0;
    var scharf = false;
    var leerlauf = null;

    setTimeout(function () { scharf = true; }, 20000);

    w.addEventListener("scroll", function () {
      var y = w.scrollY || 0;
      if (scharf && (letzteY - y) > 240) {       /* spuerbar nach oben gewischt */
        scharf = false;
        if (vielleichtExitZeigen("scroll")) raeumeAuf();
      }
      letzteY = y;
      leerlaufNeu();
    }, { passive: true });

    function leerlaufNeu() {
      if (leerlauf) clearTimeout(leerlauf);
      leerlauf = setTimeout(function () {
        if (vielleichtExitZeigen("leerlauf")) raeumeAuf();
      }, 45000);
    }
    function raeumeAuf() {
      if (leerlauf) clearTimeout(leerlauf);
      leerlauf = null;
    }
    ["touchstart", "click", "keydown"].forEach(function (ev) {
      w.addEventListener(ev, leerlaufNeu, { passive: true });
    });
    leerlaufNeu();
  }

  wireExitIntent();
  wireExitIntentMobil();
  if (CFG.loader) { beobachteVorher(); wireRueckkehr(); }

  /* ══ Start ══ */
  if (CFG.loader) restoreOrBoot();   /* nur Kalkulator-Seite (v360: Script lädt global) */
  if (d.readyState === "loading") d.addEventListener("DOMContentLoaded", observe);
  else observe();

})(window, document);
